import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
import { Component, Input, OnInit, NgModule, OnDestroy } from '@angular/core';
import { DispatcherHomeService } from './dispatcherhome.service';
import {
  FormGroup,
  AbstractControl,
  FormBuilder,
  Validators
} from '@angular/forms';
// import { MissionService } from '../../app.constant';
import { MqttServiceService } from '../../mqtt-service.service';
import { Router } from '@angular/router';
import { Configuration } from '../../app.configuration';
import * as myGlobals from '../../globals';
import { DispatcherService } from '../dispatcher.service';
import { Paho } from 'ng2-mqtt/mqttws31';
import { ConfigService } from '../../config.service';
import { CommunicationService } from '../communication.service';
// import { cleanSession } from 'selenium-webdriver/safari';
import * as uniqBy from 'lodash.uniqby';
import { mapStyle } from '../../utils/mapStyles';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
// import { PassThrough } from 'stream';
// import { LoginService }   from './login.service';
declare const jQuery: any;
declare var google: any;
declare var $: any;
declare var value: any;
declare var flatpickr: any;
declare var flatpickr2: any;
declare var PUBNUB: any;
declare var moment: any;
declare var swal: any;
declare var toastr: any;
//  var mapboxgl = require('mapbox-gl');

@Component({
  selector: 'dispatcherhome',
  animations: [
    trigger('myAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('400ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './dispatcherhome.component.html',
  styleUrls: ['./dispatcherhome.component.css']
})
export class DispatcherHomeComponent implements OnInit, OnDestroy {
  @Input()
  fp_incr: any;
  pickuplat;
  pickuplong;
  droplat;
  droplong;
  photo;
  vechiletypes: any;
  approx: any;
  vehicle_device_id: any;
  info;
  Path;
  zpath: any;
  data: any;
  data1 = [];
  data2 = [];
  data3 = [];
  getdata;
  own_lat_long: any;
  own_later_date;
  rec_name: any;
  rec_number: any;
  rec_mail: any;
  rec_lat_long: any;
  product_det: any;
  product_qty: any;
  product_wgt: any;
  vechicle_type: any;
  passDetailsContent: any;
  dynamic_latlong: any;
  file: any;
  show_otp: false;
  fname_b: any;
  map: any;
  marker: any;
  style: any;
  fmail_b: any;
  pubnub: any;
  current_time: any;
  current_time_var: any;
  public form: FormGroup;
  public phoneNumber: AbstractControl;
  public password: AbstractControl;
  public submitted = false;
  assigned_count: any = 0;
  assigned_full_count: any = 0;
  completed_count: any = 0;
  mapr: any;
  page_index: any = 0;
  route_map_lt;
  route_map_lng;
  route_map_driver_lat;
  route_map_driver_lng;
  directions: any;
  polyline: any;
  // GODS VIEW MARKERS VARIABLES
  drivers_list = [];
  markers_number = 0;
  drivers_layer: any;
  drivers_lat_long = [];
  overlayMaps: any;
  route_markers = [];
  driver_lat_route: any;
  driver_lng_route: any;
  driver_markers_inst: any;
  drivers_timings = [];
  driver_timing_singal: any;
  driver_online_offline: any;
  driver_online_email: any;
  difference_of_timings: any;
  picker_date: any;
  drop_date: any;
  picker_bool = false;
  server_time: any;
  first_render = 0;
  fphone_b: any;
  online_drivers = [];
  offline_drivers = [];
  total_drivers = [];
  ent_lati = '19.6008014678955';
  ent_long = '-99.2285003662109';
  driver_latlong_change: any;
  map1: any;
  allroute_markers = [];
  directionsDisplay: any;
  myname = sessionStorage.getItem('custname');
  myphn = sessionStorage.getItem('custphn');
  mymail = sessionStorage.getItem('custmail');
  changing_location_data = [];
  changing_location_status: any;
  current_driver_marker: any;
  path_his = [];
  otp_entered: any;
  current_location_marker: any;
  current_driver = {
    Device_type_: '',
    a: '',
    app_version: '',
    battery_Per: '',
    bid: '',
    lg: '',
    lt: '',
    location_check: '',
    st: ''
  };
  allpath_markers = [];
  show_drivers = false;
  cancellation_bid: any;
  cancel_reasons = [];
  currency: any;
  pathline: any;
  onLoadLatitude: any;
  onLoadLongitude: any;
  /** CANCEL BOOKING VARIABLES*/
  cancellation_fee: any;
  cancellation_reason: any;
  //  ent_lati = "12.9716";
  //  ent_long =  "77.5946";

  // new booking details

  offers = [];
  past_jobs = [];
  showbooking_content: any;
  map_loader = true;
  total_offers_count = 0;
  offers_incall = false;
  offers_limit = 30;
  offers_skip = 0;

  // my booking details

  assigned_jobs = [];
  total_assigned_count = 0;
  assigned_incall = false;
  assigned_limit = 50;
  assigned_skip = 0;

  // negotiation variables

  shownegos_content: any;
  negotiations = [];
  new_negotiations = [];
  old_negotiations = [];
  negotiation_bid: any;
  current_bid_item: any;
  counter_price: any;
  negos_loader = false;
  negos_history = [];
  in_history_bid = {
    lprice: '',
    _id: ''
  };
  accept_offer_details = {
    aPrice: '',
    img: '',
    latLong: '',
    mPrice: '',
    name: '',
    rating: '',
    status: '',
    time: '',
    _id: '',
    driverId: ''
  };
  current_assigned_count: any;
  // New api booking variables
  unassignedCount = 0;
  assignedCount = 0;
  pastCount = 0;
  bookcomplete: any;

  filter = '';
  sort = '';
  searchStr = '';
  sorting_vechicletype = '';
  selected_vehicletype = [];
  search_driver_text: any;
  filtered_drivers = [];
  filtered_drivers_offline = [];
  filtered_drivers_total = [];
  dispatch_drivers_list = [];
  filtered_drivers_busy = [];
  dispatchedDriverIdArray = [];
  driverArray = [];
  filtered_bid: any;
  currentBookingID: any;
  loadPickupTime: any;

  mqttStatus: any;
  mqttlat: any;
  mqttlong: any;
  mqttlatlong: any = [];
  client: any;
  showingVehicleMarker: any;
  aws = myGlobals.aws;
  dispatcherId;
  showOnlyOperatorDrivers = false;
  intervalTimersArray = [];
  cancellationCustomerId: any;
  bookingLoader = false;
  subscription: Subscription;
  current_lat: any;
  current_lng: any;
  invoice_url = myGlobals.INVOICE_URL;
  enableDimensions = myGlobals.enableDimensions;

  constructor(
    private _dispatcherHomeService: DispatcherHomeService,
    fb: FormBuilder,
    private _router: Router,
    private _conf: Configuration,
    private _missionService: MqttServiceService,
    private _dispatcherService: DispatcherService,
    private _cookie: ConfigService,
    private _communicate: CommunicationService
  ) {
    _missionService.missionAnnounced$.subscribe((data: any) => {
      if (data.status == undefined) {
        data = JSON.parse(data);
      }
      // console.log(typeof [data], data);

      if (data.bookingType === 1) {
        this.bookingCount();
        this.getmyjobs(1);
        // this.getmyjobs(2);
        this.getmyjobs(3);
        if (
          this.showbooking_content &&
          data.bid == this.showbooking_content.bookingId
        ) {
          this.showbooking_content = [];
          const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
            'rotate_pointer'
          );
          if (!isRightMarkerIsOpen) {
            jQuery('.right_marker').trigger('click');
          }
        }
        return;
      }
      if (data.negotiation != undefined) {
        data.status = data.negotiation.status
          ? data.negotiation.status
          : data.status;
      } else {
        data.status = data.status;
      }

      if (data.status == 99) {
        this.clearArray();
      }
      console.log('dispatcher home mqtt', data);
      const status = data.status;
      switch (status) {
        case 1:
          this.new_job(data);
          // this.getmyjobs(1);
          this.getmyjobs(1);
          // this.getmyjobs(2);
          // this.getmyjobs(3);
          this.bookingCount();

          break;
        case 101:
          this.driver_accepted(data);
          this.bookingCount();

          break;
        case 102:
          this.driver_counter(data);
          this.bookingCount();

          break;
        case 103:
          this.customer_counter(data);
          this.bookingCount();

          break;
        case 104:
          // console.log('dataaaaaaaaaaaaa', data);
          this.customer_accepted(data);
          this.bookingCount();

          break;
        case 2:
          data && data.emergency ?
            (swal({
              title: 'Emergency?',
              text:
                `Load Id : ${data.bookingId}
                 Have requested for emergency alert. Please check`,
              icon: 'warning',
              buttons: false,
              dangerMode: false
            }), $("#body_" + data.bookingId).addClass('emergency'))
            : (
              this.change_booking_assigned(data),
              this.bookingCount()
            );
          // toastr['error'](
          //   '<h5><strong>Load Id :</strong> ' +
          //   data.bookingId +
          //   '<br><br>' +
          //   '<strong>status : Have requested for emergency alert. Please check</strong> ' +
          //   ' </h5>'
          // )
          // : '';
          break;
        case 3: // customer cancel before accept
          this.bookingCount();
          this.getmyjobs(1);
          this.getmyjobs(2);
          this.getmyjobs(3);
          break;
        case 4: // customer cancel after accept
          // this.customerCancelled(data);
          // console.log('dispatcher home case 4');
          this.customerCancelAfterAccept(data);
          this.bookingCount();

          break;
        case 5: // driver started
          this.driverCancelled(data);
          this.bookingCount();

          break;
        case 6: // driver on the way
          this.driverOnTheWay(data);
          this.changeStatusText(data);
          break;
        case 7: // driver arrived
          this.driverArrived(data);
          this.changeStatusText(data);
          break;
        case 8: // driver loaded
          // this.changeStatusText(data);
          break;
        case 9: // trip started
          this.tripStarted(data);
          this.changeStatusText(data);
          break;
        case 10: // reached to drop location
          this.reachedDrop(data);
          this.changeStatusText(data);
          break;
        case 11: // unloaded
          this.deliveryUnloaded(data);
          this.changeStatusText(data);
          break;
        case 12: // completed
          this.driverCompleted(data);
          this.bookingCount();

          // this.pending_reviews();
          break;
        case 13: // expired
          this.expireBooking(data);
          this.bookingCount();

          break;
        case 16: // driver unloaded
          this.changeBookingStatus(data);
          break;
        case 10:
          this.bookingCompleted(data);
          this.bookingCount();

          break;
        case 14:
          this.biddingStopped(data);
          break;
        case 15:
          toastr['success'](`${data.statusText} ${data.bookingId}`);
          this.bookingCount();
          this.getmyjobs(1);
          this.getmyjobs(2);
          break;
        case 22:
          toastr['success'](`Booking Requested to the Driver(${data.email})`);
          break;
        case 21:
          toastr['success'](`${data.statusText} ${data.bookingId}`);
          break;
        case 17:
          swal({
            title: 'Are you sure?',
            text:
              'Google key Limit is Exceeded Please Conform to Reload the Page or Reload the Page Manually',
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then(willDelete => {
            if (willDelete) {
              window.location.reload();
            } else {
              swal('Please Reload the Page to Work flawlessly');
            }
          });
          break;
        // case 99:
        //   this.clearArray();
        //   break;
      }
      // if (data && data.status >= 7 && data.status <= 11 && data && data.emergency) {
      //   console.log('remoeved ', $("#body_" + data.bookingId).hasClass("blink"))
      //   swal({
      //     title: 'Emergency?',
      //     text:
      //       `Load Id : ${data.bookingId}
      //            Have requested for emergency alert. Please check`,
      //     icon: 'warning',
      //     buttons: false,
      //     dangerMode: false
      //   });
      //   if ($("#body_" + data.bookingId).hasClass("blink")) {
      //     console.log('remoeved ', $("#body_" + data.bookingId).hasClass("blink"))
      //     setTimeout(function () {///workaround
      //       $("#body_" + data.bookingId).removeClass("blink");
      //       $("#body_" + data.bookingId).addClass('emergency');
      //     }, 10);
      //   }
      //   else {
      //     setTimeout(function () {///workaround
      //       $("#body_" + data.bookingId).removeClass("blink");
      //       $("#body_" + data.bookingId).addClass('emergency');
      //     }, 200);
      //   }
      //   // $("#body_" + data.bookingId).attr("class", "blink"), $("#body_" + data.bookingId).addClass('emergency')
      // }
      //  console.log("onlinedrivers++++++++++++++++++++++++++++",data);
      //  if(this.changing_location_data.length==0){
      //          this.changing_location_data.push(data);
      //          this.changindriver_loc(data);
      //  }
      //  else{
      //          for(var inst=0;inst<this.changing_location_data.length;inst++){
      //            if(this.changing_location_data[inst].bid==data.bid){
      //             this.changing_location_data.splice(inst,1);
      //             this.changing_location_data.splice(0, 0,data);
      //             this.changindriver_loc(data);
      //              break;
      //            }
      //            else if(inst == this.changing_location_data.length-1){
      //              if(this.changing_location_data[inst].bid!=data.bid){
      //              this.changing_location_data.push(data);
      //              this.changindriver_loc(data);
      //              break;
      //              }
      //              else{
      //              this.changing_location_data.splice(inst,1);
      //              this.changing_location_data.splice(0, 0,data);
      //              this.changindriver_loc(data);
      //              break;
      //              }
      //            }

      // if(this.current_driver.bid==this.changing_location_data[inst].bid){
      // this.current_driver.Device_type_ = this.changing_location_data[inst].Device_type_;
      // this.current_driver.a = this.changing_location_data[inst].a;
      // this.current_driver.app_version = this.changing_location_data[inst].app_version;
      // this.current_driver.battery_Per = this.changing_location_data[inst].battery_Per;
      // this.current_driver.lg = this.changing_location_data[inst].lg;
      // this.current_driver.lt = this.changing_location_data[inst].lt;
      // this.current_driver.location_check = this.changing_location_data[inst].location_check;
      // this.current_driver.st = this.changing_location_data[inst].st;
      // }
      //         }
      //  }
    });
    this.form = fb.group({
      phoneNumber: ['', Validators.compose([Validators.required])],
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(4)])
      ]
    });

    this.phoneNumber = this.form.controls['phoneNumber'];
    this.password = this.form.controls['password'];
  }

  public onSubmitLogin(values: Object): void {
    this.submitted = true;

    if (this.form.valid) {
      // your code goes here
    }
  }

  mqttsubscribe(driver, res) {
    const channel = driver.driverDetails.mqttLocationTopic;
    // const driverLatLongs = driver.driverDetails.driversLatLongs.split(',');
    const pos1 = new google.maps.LatLng(
      parseFloat(res.driverLocation.latitude),
      parseFloat(res.driverLocation.longitude)
    );
    const icn = {
      url: driver.vehicleType.vehicleMapIcon, // url
      scaledSize: new google.maps.Size(50, 50), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(0, 0) // anchor
    };
    this.showingVehicleMarker = new google.maps.Marker({
      position: pos1,
      icon: icn,
      map: this.map1
    });
    this.showingVehicleMarker.id = driver.driverDetails.driverId;
    // this.allroute_markers.push(this.showingVehicleMarker);
    this.client = new Paho.MQTT.Client(
      myGlobals.MQTT_HOST,
      'myClientId' + new Date().getTime()
    );
    this.client.onConnectionLost = (responseObject: Object) => {
      console.log('Connection Lost :(', responseObject);
      const options = {
        userName: myGlobals.MQTT_USERNAME,
        password: myGlobals.MQTT_PASSWORD,
        useSSL: myGlobals.MQTT_USESSL,
        timeout: 60,
        keepAliveInterval: 15,

        // Gets Called if the connection has successfully been established

        onSuccess: () => {
          console.log('connected', channel);
          this.client.subscribe(channel, { qos: 2 });
          // this.client.subscribe('godsview/location', { qos: 2 });
        },
        // Gets Called if the connection could not be established
        onFailure: function (message) {
          // alert('failure');
          console.log('Connection failed:.' + message.errorMessage);
          this.client.unsubscribe(channel);
          this.client.isConnected() ? this.client.disconnect() : '';
          this.client.isConnected() ? this.client.connect(options) : '';
          //                alert("Connection failed: " + message.errorMessage);
        }
      };
    };

    this.client.onMessageArrived = (message: Paho.MQTT.Message) => {
      // console.log('JSON.parse(message.payloadString)', JSON.parse(message.payloadString));
      const response = JSON.parse(message.payloadString);
      // const responseDriverId = response.driverId;
      if (this.showingVehicleMarker) {
        if (this.showingVehicleMarker.id && response.transit == 1) {
          console.log(
            'Location Updated :)',
            response,
            response.transit,
            response.latitude,
            response.longitude
          );
          // console.table(response);
          const latlng = new google.maps.LatLng(
            response.latitude,
            response.longitude
          );
          this.map1.panTo(latlng);
          this.showingVehicleMarker.setPosition(latlng);
          const marker = new google.maps.Marker({
            position: latlng,
            icon: myGlobals.pathicn,
            scaledSize: new google.maps.Size(30, 30),
            map: this.map1
          });
          this.path_his.push(marker);
          const path = this.pathline.getPath();
          path.push(latlng);
          // Because path is an MVCArray, we can simply append a new coordinate
          // and it will automatically appear.
        } else {
          console.log(
            'Vehicle is Idle :(',
            response.transit,
            response.latitude,
            response.longitude
          );
          // console.table(response);
        }
      } else {
        console.warn('Disconneted from Live track', channel);
        this.client.unsubscribe(channel);
        this.client.isConnected() ? this.client.disconnect() : '';
        // this.client.disconnect();
      }
    };

    const options = {
      userName: myGlobals.MQTT_USERNAME,
      password: myGlobals.MQTT_PASSWORD,
      useSSL: myGlobals.MQTT_USESSL,
      timeout: 60,
      keepAliveInterval: 15,

      // Gets Called if the connection has successfully been established

      onSuccess: () => {
        console.log('connected', channel);
        this.client.subscribe(channel, { qos: 2 });
        // this.client.subscribe('godsview/location', { qos: 2 });
      },
      // Gets Called if the connection could not be established
      onFailure: function (message) {
        // alert('failure');
        this.client.unsubscribe(channel);
        this.client.isConnected() ? this.client.disconnect() : '';
        console.log('Connection failed:.' + message.errorMessage);
        //                alert("Connection failed: " + message.errorMessage);
      }
    };
    console.log('mqtt connected')
    !this.client.isConnected() ? this.client.connect(options) : '';
  }

  pickupDocsUpdated(data) {
    const indexOfBooking = this.assigned_jobs.findIndex(
      i => i.bookingId == data.bookingId
    );
    if (indexOfBooking !== -1) {
      for (
        let pickDocs = 0;
        pickDocs < data.bookingDocuments.pickup.length;
        pickDocs++
      ) {
        this.assigned_jobs[indexOfBooking].bookingDocuments.pickup.push(
          data.bookingDocuments.pickup[pickDocs]
        );
      }
    }

    if (indexOfBooking == 0) {
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 1000);
    } else {
      if (indexOfBooking !== -1) {
        const bookingData = this.assigned_jobs[indexOfBooking];
        this.assigned_jobs.splice(indexOfBooking, 1);
        this.assigned_jobs.splice(0, 0, bookingData);
        setTimeout(() => {
          $('#body_' + data.bookingId).addClass('blink');
        }, 1000);
      } else {
        // call single booking
      }
    }
  }
  // change booking status text on realtime by vivek
  changeStatusText(data) {
    setTimeout(() => {
      $(
        `#body_${data.bookingId} .myoffer_footer.offers_txt .no_offers_count`
      ).text(data.statusText);
    }, 1500);
    // console.log('changeStatusText', this.showbooking_content);
    if (
      this.showbooking_content &&
      data.bookingId == this.showbooking_content.bookingId
    ) {
      switch (data.status) {
        case 6:
          this.showbooking_content.timeStamp.onTheWay = moment().unix();
          break;
        case 7:
          this.showbooking_content.timeStamp.arrived = moment().unix();
          break;
        case 8:
          this.showbooking_content.timeStamp.loaded = moment().unix();
          break;
        case 9:
          this.showbooking_content.timeStamp.journeyStart = moment().unix();
          break;
        case 10:
          this.showbooking_content.timeStamp.reachedDrop = moment().unix();
          break;
        case 11:
          this.showbooking_content.timeStamp.unloaded = moment().unix();
          break;
      }
    }
  }
  // TODO: function should also check the past_jobs array
  shiftBookingToTop(data, assigned?) {
    // console.log(this.past_jobs);
    const indexOfBooking = this.assigned_jobs.findIndex(
      i => i.bookingId == data.bookingId
    );
    const pastJobsIndexOfBooking = this.past_jobs.findIndex(
      i => i.bookingId == data.bookingId
    );
    console.log('shiftBookingToTop', indexOfBooking, pastJobsIndexOfBooking);
    // if already at start, nothing to do
    if (indexOfBooking != -1) {
      this.assigned_jobs[indexOfBooking].bookingStatus = data.status;
      this.assigned_jobs[indexOfBooking].bookingStatusText = data.statusText;
      switch (data.status) {
        case 7:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.arrived = moment().format('DD MMM  YYYY, hh mm a');
          break;
        case 9:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.journeyStart = moment().format('DD MMM  YYYY, hh mm a');
          break;
        case 10:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.reachedDrop = moment().format('DD MMM  YYYY, hh mm a');
          break;
        case 11:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.unloaded = moment().format('DD MMM  YYYY, hh mm a');
          break;
      }
    } else if (indexOfBooking == -1) {
      // this._dispatcherHomeService.getBookingDetails(data.bookingId, 2).subscribe(
      //   (data: any) => {
      //     console.log(data);
      //   }, err => {
      //     console.log(err);
      //   }
      // );
    }
    // console.log('shift booking', this.assigned_jobs[indexOfBooking]);
    if (indexOfBooking == 0) {
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 1000);
    } else {
      if (indexOfBooking != -1) {
        const bookingData = this.assigned_jobs[indexOfBooking];
        this.assigned_jobs.splice(indexOfBooking, 1);
        this.assigned_jobs.splice(0, 0, bookingData);
        setTimeout(() => {
          $('#body_' + data.bookingId).addClass('blink');
        }, 1000);
      } else {
        // call single booking
      }
    }
    // shift booking if it is in pastjobs
    if (pastJobsIndexOfBooking == 0) {
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 1000);
      // console.log($('#body_' + data.bookingId));
    } else if (pastJobsIndexOfBooking != -1) {
      const bookingData = this.past_jobs[pastJobsIndexOfBooking];
      this.past_jobs.splice(pastJobsIndexOfBooking, 1);
      this.past_jobs.splice(0, 0, bookingData);
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 1000);
    } else if (pastJobsIndexOfBooking == -1 && assigned) {
      this._dispatcherHomeService
        .getBookingDetails(data.bookingId, 3)
        .subscribe(
          (data: any) => {
            // console.log(data);
            this.currentBookingID = data.dataForDispatcher.bookingId;
            // this.loadPickupTime = data.data.pickupDate;
            this.showbooking_content = data.dataForDispatcher;
            const bookingData = data.dataForDispatcher;
            if (bookingData.bookingDateTimestamp !== '0') {
              bookingData.bookingDateTimestamp = moment
                .unix(bookingData.bookingDateTimestamp)
                .format('DD MMM  YYYY, hh : mm a');
            }
            // if (bookingData.deliveryDateTimestamp !== '0') {
            //   bookingData.deliveryDateTimestamp = moment.unix(bookingData.deliveryDateTimestamp).format('DD MMM YYYY, hh : mm a');
            // }
            if (bookingData.timeStamp.created !== '0') {
              bookingData.timeStamp.created = moment(
                bookingData.timeStamp.created * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.expired !== 0) {
              bookingData.timeStamp.expired = moment(
                bookingData.timeStamp.expired * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.cancelled !== 0) {
              bookingData.timeStamp.cancelled = moment(
                bookingData.timeStamp.cancelled * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.accepted !== 0) {
              bookingData.timeStamp.accepted = moment(
                bookingData.timeStamp.accepted * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.arrived !== 0) {
              bookingData.timeStamp.arrived = moment(
                bookingData.timeStamp.arrived * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.reachedDrop !== 0) {
              bookingData.timeStamp.reachedDrop = moment(
                bookingData.timeStamp.reachedDrop * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.onTheWay !== 0) {
              bookingData.timeStamp.onTheWay = moment(
                bookingData.timeStamp.onTheWay * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.unloaded !== 0) {
              bookingData.timeStamp.unloaded = moment(
                bookingData.timeStamp.unloaded * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.journeyComplete !== 0) {
              bookingData.timeStamp.journeyComplete = moment(
                bookingData.timeStamp.journeyComplete * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.timeStamp.journeyStart !== 0) {
              bookingData.timeStamp.journeyStart = moment(
                bookingData.timeStamp.journeyStart * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
            if (bookingData.activities !== undefined) {
              for (
                let bookingstatus = 0;
                bookingstatus < bookingData.activities.length;
                bookingstatus++
              ) {
                bookingData.activities[bookingstatus].timeConverted = moment(
                  bookingData.activities[bookingstatus].time
                ).format('DD MMM YYYY, hh : mm a');
              }
            }
            // console.log(bookingData);
            this.past_jobs.unshift(bookingData);
            setTimeout(() => {
              $('#body_' + bookingData.bookingId).addClass('blink');
            }, 1000);
          },
          err => {
            this.handleStatus(err.status, err.error);
          }
        );
    }
  }

  customerCancelled(data) {
    this.moveToPast();
    this.passDetailsContent = '';
    this.showbooking_content = '';
    this.negotiations = [];
    this.old_negotiations = [];
    this.new_negotiations = [];
  }

  driverCancelled(data) {
    // driver cancelled
    $('#' + data.bookingId).addClass('remove');
    if (this.showbooking_content !== undefined) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        this.showbooking_content = '';
        this.passDetailsContent = '';
        this.new_negotiations = [];
        this.old_negotiations = [];
        this.negotiations = [];
      }
    }
    setTimeout(() => {
      const indexofBooking = this.assigned_jobs.findIndex(
        i => i.bookingId == data.bookingId
      );
      if (indexofBooking !== -1) {
        // console.log(this.assigned_jobs[indexofBooking]);
        this.assigned_jobs[indexofBooking].bookingStatus = 5;
        this.assigned_jobs[indexofBooking].bookingStatusText =
          'Driver Cancelled';
        this.past_jobs.splice(0, 0, this.assigned_jobs[indexofBooking]);
        this.assigned_jobs.splice(indexofBooking, 1);
        this.assignedCount--;
        this.pastCount++;
      } else {
        // call single booking and push to past bookings
      }
    }, 1000);
  }

  driverOnTheWay(data) {
    // console.log('driverOnTheWay--------->', data);
    this.shiftBookingToTop(data, true);
  }
  driverArrived(data) {
    // console.log('driverArrived--------->', data);
    // FIXME: mqtt disconnects
    // if (data.bookingDocuments.pickup.length == 0) {
    //   this.shiftBookingToTop(data);
    // } else {
    //   this.pickupDocsUpdated(data);
    // }
    if (data) {
      this.shiftBookingToTop(data, true);
    } else {
      this.pickupDocsUpdated(data);
    }
    // this.getmyjobs(3);
  }
  tripStarted(data) {
    this.shiftBookingToTop(data, true);
  }
  biddingStopped(data) {
    console.log('databidingexpired');
  }
  reachedDrop(data) {
    this.shiftBookingToTop(data, true);
  }
  deliveryUnloaded(data) {
    this.shiftBookingToTop(data, true);
  }
  dcomplete = false;
  driverCompleted(data) {
    this.dcomplete = true;
    const indexofBooking = this.assigned_jobs.findIndex(
      i => i.bookingId == data.bookingId
    );
    $('#' + data.bookingId).addClass('remove');
    if (this.showbooking_content !== undefined) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        this.showbooking_content = '';
        this.passDetailsContent = '';
        this.new_negotiations = [];
        this.old_negotiations = [];
        this.negotiations = [];
        this.clearallpassdetails();
        const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
          'rotate_pointer'
        );
        if (!isRightMarkerIsOpen) {
          jQuery('.right_marker').trigger('click');
        }
      }
    }
    // if (indexofBooking !== -1) {
    //   setTimeout(() => {
    //     this.assigned_jobs.splice(indexofBooking, 1);
    //   }, 1000);
    // }
    if (this.pathline || this.pathline != undefined) {
      this.pathline.setMap(null);
      this.allpath_markers = [];
    }
    // this.singleBooking(data.bookingId, data.status);
    // this.bookingCount();
    this.assigned_jobs = [];
    this.getmyjobs(2);
    this.past_jobs = [];
    this.getmyjobs(3);
    console.log('live show showing')
  }

  handleStatus(statuscode, errMsg) {
    // console.log('HandleStatus', statuscode, errMsg, err);
    $('.modal').modal('hide');
    if (statuscode >= 500) {
      statuscode = 500;
    }
    switch (statuscode) {
      case 401:
        this._cookie.removeItem();
        this._router.navigate(['login']);
        sessionStorage.clear();
        // toastr['warning']('You have been logged out. Please login to continue');
        break;
      case 500:
        toastr['warning']('Could not connect to server');
        break;
      default:
        toastr['warning'](errMsg.message);
        break;
    }
  }

  changeBookingStatus(data) {
    const indexOfbookings = this.assigned_jobs.findIndex(i => i.id == data.id);
    $('#body_' + data.id).addClass('blink');
    if (indexOfbookings !== -1) {
      this.assigned_jobs[indexOfbookings].status = data.status;
      this.assigned_jobs[indexOfbookings].statusTxt = data.statusTxt;
      data.timeConverted = moment
        .unix(data.time / 1000)
        .format('DD MMM  YYYY, hh mm a');
      if (this.assigned_jobs[indexOfbookings].activities == undefined) {
        this.assigned_jobs[indexOfbookings].activities = [];
      }
      this.assigned_jobs[indexOfbookings].activities.push(data);
    }
  }
  bookingCompleted(data) {
    const indexOfbookings = this.offers.findIndex(i => i.id == data.bid);
  }
  changindriver_loc(data) {
    if (this.current_driver.bid == data.bid) {
      if (
        this.changing_location_status == 6 ||
        this.changing_location_status == 7 ||
        this.changing_location_status == 8 ||
        this.changing_location_status == 9 ||
        this.changing_location_status == 16
      ) {
        this.current_driver.Device_type_ = data.Device_type_;
        this.current_driver.a = data.a;
        this.current_driver.app_version = data.app_version;
        this.current_driver.battery_Per = data.battery_Per;
        this.current_driver.bid = data.bid;
        this.current_driver.lg = data.lg;
        this.current_driver.lt = data.lt;
        this.current_driver.location_check = data.location_check;
        this.current_driver.st = data.st;
        const latlng = new google.maps.LatLng(data.lt, data.lg);
        this.current_driver_marker.setPosition(latlng);
        const latlongobj = {
          lat: this.current_driver.lt,
          lng: this.current_driver.lg
        };
        this.allpath_markers.push(latlongobj);
        const pos1 = new google.maps.LatLng(
          parseFloat(this.current_driver.lt),
          parseFloat(this.current_driver.lg)
        );
        const infowindow = new google.maps.InfoWindow();
        const marker = new google.maps.Marker({
          position: pos1,
          icon: myGlobals.pathicn,
          map: this.map1
        });
        const content = this.current_driver.st;
        google.maps.event.addListener(
          marker,
          'mouseover',
          (function (marker, content, infowindow) {
            return function () {
              infowindow.setContent(content);
              infowindow.open(this.map1, marker);
            };
          })(marker, content, infowindow)
        );
        this.path_his.push(marker);
        const lineSymbol = {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };
        this.pathline = new google.maps.Polyline({
          path: this.allpath_markers,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          strokeColor: '#4eff04',
          icons: [
            {
              icon: lineSymbol,
              repeat: '300px',
              strokeColor: 'red',
              offset: '100%'
            }
          ],
          map: this.map1
          // editable: true,
        });
      }
    }
  }

  fileEvent(fileInput: any) {
    this.file = fileInput.target.files[0];
  }

  hideShow_job() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#job_details_button').addClass('active');
    $('.details_description').show();
  }
  hideShow_activity() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#activity_timeline_button').addClass('active');
    $('.details_description2').show();
  }
  hideShow_path() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#path_history_button').addClass('active');
    $('.details_description3').show();
  }
  hideShow_docs() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#documents_show').addClass('active');
    $('.details_description4').show();
  }
  hideShow_invoice() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#invoice_show').addClass('active');
    $('.details_description5').show();
  }

  cancellationFee(bid) {
    this._dispatcherHomeService
      .cancelfees({
        bookingId: bid
      })
      .subscribe((res: any) => {
        console.log('cancellationFee', res);
        this.cancellation_reason = res.message;
      });
  }

  serviceType = 2;
  cancelReason(booking) {
    const bid = booking.bookingId;
    this.cancellation_bid = bid;
    this.cancellationCustomerId = booking.slaveDetails.slaveId;
    // if the booking is assigned then call cancellation fee
    let bookingStatus;
    // if (booking.bookingStatus == 1 || (booking.bookingStatus == 2 && booking.unAssigned)) {
    //   this.cancellation_fee = 0;
    //   // this.cancelBasedOnStatus();
    //   bookingStatus = 2;
    // } else {
    //   bookingStatus = 1;
    //   this.cancellationFee(bid);
    // }
    console.log('unasgnTab', this.unasgnTab, booking.bookingStatus);
    if (booking.bookingStatus === 1) {
      this.cancellation_fee = 0;
      bookingStatus = 2;
      // this.cancelappt();
      // return;
    } else {
      bookingStatus = 1;
      this.cancellation_fee = 1;
      this.cancellationFee(bid);
    }
    // if (this.unasgnTab == 1) {
    //   this.cancellation_fee = 0;
    //   bookingStatus = 1;
    // } else {
    //   bookingStatus = 2;
    //   this.cancellation_fee = 1;
    //   this.cancellationFee(bid);
    // }
    $('.booking_loader_parent').show();
    this.cancel_reasons = [];
    this.cancellation_bid = '';
    this._dispatcherHomeService
      .cancelreasons({
        entityType: 1,
        serviceType: this.serviceType,
        type: bookingStatus
      })
      .subscribe(
        (res: any) => {
          console.log('cancelReason', res);
          $('.booking_loader_parent').hide();
          res.data.bid = bid;
          for (let inst = 0; inst < res.data.length; inst++) {
            this.cancel_reasons.push(res.data[inst]);
          }
          // console.log('this.cancel_reasons', this.cancel_reasons);
          // this.cancel_reasons = res.data.reasons;
          $('#appcancel_rs').modal('show');
          $('#details_task').modal('hide');
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  // cancellation after accept
  cancelserviceAfterAccept() { }

  live_path_show(item) {
    this.clearallpassdetails();
    if (this.pathline || this.pathline != undefined) {
      // this.pathline.setMap(null);
      this.allpath_markers = [];
    }
    else {
      this.allpath_markers = [];
      this.pathline = '';
    }
    setTimeout(() => {
      this.map_loader = false;
      const pickupMarkerLoc = new google.maps.LatLng(
        item.pickup.location.latitude,
        item.pickup.location.longitude
      );
      const driverMarkerLoc = new google.maps.LatLng(
        item.drop.location.latitude,
        item.drop.location.longitude
      );
      const pickupMarker = new google.maps.Marker({
        position: pickupMarkerLoc,
        icon: myGlobals.pickupicn,
        map: this.map1
      });
      this.allroute_markers.push(pickupMarker);
      const driverMarker = new google.maps.Marker({
        position: driverMarkerLoc,
        icon: myGlobals.dropupicn,
        map: this.map1
      });
      this.allroute_markers.push(driverMarker);
    }, 1000);

    let map_plot;
    map_plot = this.map1;
    this._dispatcherHomeService
      .livePath({
        bookingId: item.bookingId
      })
      .subscribe(
        (res: any) => {
          console.log('live_path_show', res);
          let stops = 0;
          if (res.data['6'] !== undefined) {
            stops = stops + res.data['6'].length;
          }
          if (res.data['7'] !== undefined) {
            stops = stops + res.data['7'].length;
          }
          if (res.data['8'] !== undefined) {
            stops = stops + res.data['8'].length;
          }
          if (res.data['9'] !== undefined) {
            stops = stops + res.data['9'].length;
          }
          if (res.data['16'] !== undefined) {
            stops = stops + res.data['16'].length;
          }
          if (stops > 0) {
            const bounds = new google.maps.LatLngBounds();
            const infowindow = new google.maps.InfoWindow();
            if (res.data['6'] !== undefined) {
              let icn;
              for (let inst = 0; inst < res.data['6'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['6'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Driver on the way';

                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  ((marker, content, infowindow) => {
                    return () => {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );

                google.maps.event.addListener(
                  marker,
                  'mouseleave',
                  ((marker, content, infowindow) => {
                    return () => {
                      infowindow.close();
                    };
                  })(marker, content, infowindow)
                );

                this.path_his.push(marker);
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['7'] !== undefined) {
              let icn;
              for (let inst = 0; inst < res.data['7'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn2;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['7'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Driver reached to pickup address';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(this.map1, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['9'] !== undefined) {
              let icn;
              for (let inst = 0; inst < res.data['9'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn3;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['9'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Loaded and trip started';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['10'] !== undefined) {
              let icn;
              for (let inst = 0; inst < res.data['10'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn4;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['10'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Reached to drop location';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['11'] !== undefined) {
              let icn;
              for (let inst = 0; inst < res.data['11'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn5;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['11'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Unloaded';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['12'] !== undefined) {
              let icn;
              for (let inst = 0; inst < res.data['12'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn6;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['12'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Booking Completed';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            // console.log('this.path_his', this.path_his);
            const lineSymbol = {
              path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
            };
            this.pathline = new google.maps.Polyline({
              path: this.allpath_markers,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              strokeColor: '#4eff04',
              icons: [
                {
                  icon: lineSymbol,
                  repeat: '300px',
                  strokeColor: 'red',
                  offset: '100%'
                }
              ],
              map: map_plot
            });
            if (item.bookingStatus !== 12) {
              console.log('mqtt subscribe', item, res.data);
              this.mqttsubscribe(item, res.data);
            }

            // Polyline properties are defined below
            // var lineOptions = {
            //     path: this.allpath_markers,
            //    icons: [{
            //        icon: lineSymbol,
            //        repeat: '300px',
            //         strokeColor: 'red',
            //      offset: '100%'
            //   }],
            //     strokeWeight: 3,
            //     strokeColor: '#FF0000',
            //     strokeOpacity: 0.8
            // }

            // var polyline = new google.maps.Polyline(lineOptions);
            // polyline.setMap(this.map1);
            // var counter = 0;
            // var accessVar = window.setInterval(function() {
            //     counter = (counter + 1) % 350;

            //     var arrows = polyline.get('icons');
            //     arrows[0].offset = (counter / 2) + '%';
            //     polyline.set('icons', arrows);
            // }, 50);

            // console.log('bounds', bounds);
            // this.map1.setCenter(bounds.getCenter(), this.map1.getBoundsZoomLevel(bounds));
            // this.map1.setZoom(2);
            // console.log(this.map1.getZoom());
          } else {
            this.showgooglepath();
          }
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  expireBooking(data) {
    this.bookingCount();
    $('#' + data.bookingId).addClass('remove');
    if (this.showbooking_content && this.showbooking_content.length) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
          'rotate_pointer'
        );
        if (!isRightMarkerIsOpen) {
          jQuery('.right_marker').trigger('click');
        }
        this.showbooking_content = '';
        this.passDetailsContent = '';
        this.new_negotiations = [];
        this.old_negotiations = [];
        this.negotiations = [];
      }
    }
    // const indexofBooking = this.offers.findIndex(i => i.bookingId == data.bookingId);
    // this.assigned_jobs = [];
    this.getmyjobs(1);
    this.getmyjobs(2);
    // this.offers[indexofBooking].status = data.status;
    // this.offers[indexofBooking].statusText = data.statusText;
    // this.past_jobs.splice(0, 0, this.offers[indexofBooking]);
    // this.offers.splice(indexofBooking, 1);
    // this.unassignedCount--;
    // this.pastCount++;
    // By Vivek
    // this.offers.splice(indexofBooking, 1);
    // const indexofBooking1 = this.assigned_jobs.findIndex(i => i.bookingId == data.bookingId);
    // this.offers.splice(indexofBooking1, 1);
    // End by vivek
    // this.assigned_jobs.splice(0, 0, indexofBooking);
    // this.unassignedCount--;
    // this.assignedCount++;
  }
  // THIS FUNCTION WILL PASS THE DETAILS TO RIGHT HAND SLIDER AND DETAILS POUPUP AND SHOWS ROUTE MAP...............

  showgooglepath() {
    const pos1 = new google.maps.LatLng(
      this.passDetailsContent.pickup_lt,
      this.passDetailsContent.pickup_lg
    );
    const pos2 = new google.maps.LatLng(
      this.passDetailsContent.drop_lt,
      this.passDetailsContent.drop_lg
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker2);
    const directionsService2 = new google.maps.DirectionsService({
      preserveViewport: true
    });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: '#00ff5b' }
    });
    this.directionsDisplay.setMap(this.map1);
    const request = {
      origin: pos1, // LatLng|string
      destination: pos2, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsService2.route(request, (response, status) => {
      if (status == 'OK') {
        // console.log(response);
        const point = response.routes[0].legs[0];
        let journey_time = point.distance.value;
        journey_time = journey_time / 1000;
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(
          this.map1,
          'bounds_changed',
          event => {
            if (journey_time <= 100) {
              this.map1.setZoom(12);
            } else if (journey_time > 100 && journey_time < 500) {
              this.map1.setZoom(8);
            } else if (journey_time > 500 && journey_time < 1500) {
              this.map1.setZoom(6);
            } else if (journey_time > 1500 && journey_time < 1000) {
              this.map1.setZoom(5);
            } else if (journey_time < 1000) {
              this.map1.setZoom(3);
            }
            google.maps.event.trigger(this.map1, 'resize');
          }
        );
        setTimeout(function () {
          google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000);
        this.directionsDisplay.setDirections(response);
      }
    });
  }
  passDetails(i: number, jobid: number, item) {
    // VARIABLES COME FROM ONCLICK FUNCTION FROM THIS COMPONENT.HTML
    this.show_drivers = false;
    $('#body_' + jobid).removeClass('blink');
    $('#job_details_button').trigger('click');
    $('#right_back_div').hide();
    const that = this;
    // $("#right_back_div").hide();
    // for(var key in this.drivers_list){
    //        that.map.removeLayer(this.drivers_list[key]); // DELETES DRIVERS WHICH DISPLAYED ON LOAD MAP MARKERS
    // }
    // console.log(this.allroute_markers, 'asdfsadfmapmarkers');
    if (this.allroute_markers.length > 0) {
      for (let inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setVisible(false);
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
      //   this.directionsDisplay.setMap(null);
    }
    if (this.showingVehicleMarker !== undefined) {
      this.showingVehicleMarker.setMap(null);
    }
    if (this.pathline || this.pathline != undefined) {
      // this.pathline.setMap(null);
      this.allpath_markers = [];
    }
    if (this.directionsDisplay || this.directionsDisplay != undefined) {
      this.directionsDisplay.setMap(null);
    }
    if (this.path_his.length > 0) {
      for (let inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
      }
    }
    if (jobid == 3) {
      this.passDetailsContent = this.data3[i]; // PASSING COMPLETED TASKS DETAILS TO PASS DETAILS CONTENT
    } else if (jobid == 2) {
      this.passDetailsContent = this.data2[i]; // PASSING ASSIGNED TASKS DETAILS TO PASS DETAILS CONTENT  // BASED ON ID GOT FROM CLICK FUNCTION
    } else if (jobid == 1) {
      this.passDetailsContent = this.data1[i]; // PASSING UNASSIGNED TASKS DETAILS TO PASS DETAILS CONTENT
      this.showgooglepath();
    }

    setTimeout(() => {
      $('.left_window_body .myoffer_blocks').removeClass('active');
      $('#body_' + this.passDetailsContent.bid).addClass('active');
    }, 600);

    if (jobid == 2 || jobid == 3) {
      if (
        this.passDetailsContent.shipemntDetails[0].status == 11 ||
        this.passDetailsContent.shipemntDetails[0].status == 4 ||
        this.passDetailsContent.status == 3
      ) {
        this.showgooglepath();
      } else {
        if (this.passDetailsContent.shipemntDetails[0].status !== 10) {
          for (
            let inst = 0;
            inst < this.changing_location_data.length;
            inst++
          ) {
            if (
              this.passDetailsContent.bid ==
              this.changing_location_data[inst].bid
            ) {
              this.passDetailsContent.driverDetails.Device_type_ = this.changing_location_data[
                inst
              ].Device_type_;
              this.passDetailsContent.driverDetails.battery_Per = this.changing_location_data[
                inst
              ].battery_Per;
              this.passDetailsContent.driverDetails.app_version = this.changing_location_data[
                inst
              ].app_version;
              this.passDetailsContent.driverDetails.DriversLatLongs =
                this.changing_location_data[inst].lt +
                ',' +
                this.changing_location_data[inst].lg;
              this.passDetailsContent.driverDetails.location_check = this.changing_location_data[
                inst
              ].location_check;
              this.passDetailsContent.statusCode = this.changing_location_data[
                inst
              ].st;
              break;
            }
          }
          const splitted_content = this.passDetailsContent.driverDetails
            .DriversLatLongs;
          const lat = splitted_content.split(',');
          const pos3 = new google.maps.LatLng(lat[0], lat[1]);
          this.current_driver_marker = new google.maps.Marker({
            position: pos3,
            icon: myGlobals.vehicleicn,
            map: this.map1
          });
          this.allroute_markers.push(this.current_driver_marker);
          this.current_driver.Device_type_ = this.passDetailsContent.driverDetails.Device_type_;
          this.current_driver.a = this.passDetailsContent.driverDetails.battery_Per;
          this.current_driver.app_version = this.passDetailsContent.driverDetails.app_version;
          this.current_driver.battery_Per = parseFloat(
            this.passDetailsContent.driverDetails.battery_Per
          ).toFixed(0);
          this.current_driver.bid = this.passDetailsContent.bid;
          this.current_driver.lg = lat[0];
          this.current_driver.lt = lat[1];
          this.current_driver.location_check = this.passDetailsContent.driverDetails.location_check;
          this.current_driver.st = this.passDetailsContent.statusCode;
          this.show_drivers = true;

          console.log('this.passDetailsContent', this.passDetailsContent);
          this.changing_location_status = this.passDetailsContent.statusCode;
          this.live_path_show(this.passDetailsContent);
        } else {
          this.live_path_show(this.passDetailsContent); // completed bookings show only route path with out driver icon
        }
      }
    }

    //     for(var key in this.drivers_timings){                //ASSIGNING TIMING AND ONLINE OR OFFLINE
    //          if(this.drivers_timings[key][1]==this.passDetailsContent.DriverEmail){
    //            this.driver_timing_singal = this.drivers_timings[key][0];
    //            this.driver_online_offline = this.drivers_timings[key][2];
    //            this.driver_online_email = this.drivers_timings[key][3];
    //            break;
    //          }

    //     }

    //             // that.map.removeLayer(this.drivers_layer);
    //             // if(that.first_render>0){
    //             //   that.map.removeLayer(that.polyline);
    //             // }
    //             that.first_render++;
    //               // removing online drivers which shows online at the page loading
    //             this.drivers_layer = [] ;
    //         // SUBSCRIPTION FOR LIVE TRACKING DRIVER
    //         if(this.passDetailsContent.DriverChn!=" "&&this.passDetailsContent.shipemntDetails[0].status!=22){
    //                         this.pubnub.subscribe({

    //                                           channel: this.passDetailsContent.DriverChn.toString(),
    //                                            message: (message) => {
    //                                              console.log(message);
    //                                                              this.driver_lat_route= message.lt;
    //                                                              this.driver_lng_route=message.lg;
    //                        if(this.driver_markers_inst==0)
    //                                               {
    //                                            this.driver_markers_inst++;
    //                                            var driverIcon = L.icon({iconUrl: 'https://s3-us-west-2.amazonaws.com/lyttup/driver.png',});
    //                                            this.route_markers[2] = new L.Marker(new L.LatLng(this.driver_lat_route, this.driver_lng_route),{
    //                                            icon: driverIcon,
    //                                             } );
    //                         this.map.addLayer(this.route_markers[2]);
    //                           }
    //                         else{
    //                                           //  var driverIcon = L.icon({iconUrl: 'https://s3-us-west-2.amazonaws.com/lyttup/driver.png',});
    //                                           //  this.map.removeLayer(this.route_markers[2]);
    //                                           //  this.route_markers[2] = L.marker(([message.lt,message.lg]), {icon: driverIcon,}).update(this.route_markers[2]);
    //                                           //  this.map.addLayer(this.route_markers[2]);
    //                            }
    //                            }
    //                           })}

    //                         $(".left_window_body").removeClass("active");
    //                         $("#"+this.passDetailsContent.bid).addClass("active");

    //                         this.dynamic_latlong =this.passDetailsContent.addrLine1;
    //                         var geocoder = new google.maps.Geocoder();
    //                         this.route_map_lt = this.passDetailsContent.pickup_ltg.split(",");
    //                         this.route_map_lng = this.passDetailsContent.drop_ltg.split(",");
    //                         var address = this.dynamic_latlong;
    //                         // var pickup_icn = L.icon({iconUrl: 'https://s3-us-west-2.amazonaws.com/lyttup/Untitled-2.png',});
    //                         // var drop_icn = L.icon({ iconUrl: 'https://s3-us-west-2.amazonaws.com/lyttup/drop.png',});

    //                         // SHOWING MAP MARKERS FROM PICKUP AND DROP LOCATION
    //                         // if(this.route_markers.length>0){
    //                         //  this.map.removeLayer(this.route_markers[0]);
    //                         // this.map.removeLayer(this.route_markers[1]);
    //                         // }

    //                         // this.route_markers[0] = new L.Marker(new L.LatLng(this.route_map_lt[0], this.route_map_lt[1]), {icon: pickup_icn,title: "personname",},);
    //                         // this.route_markers[1] = new L.Marker(new L.LatLng(this.route_map_lng[0], this.route_map_lng[1]),{icon: drop_icn,});

    //       this.map.addLayer(this.route_markers[0]);
    //       this.map.addLayer(this.route_markers[1]);

    //       var group = new L.featureGroup([this.route_markers[0], this.route_markers[1]]);
    //       this.map.fitBounds(group.getBounds());
    //        var pickup_lat = parseFloat(this.route_map_lt[0]);
    //        var pickup_lng = parseFloat(this.route_map_lt[1]);
    //        var drop_lat = parseFloat(this.route_map_lng[0]);
    //        var drop_lng = parseFloat(this.route_map_lng[1]);

    // // DRAWING MAPBOX ROUTE FROM PICKUP LOCATIOAN AND DROP LOCATION

    // var MapboxClient = require('mapbox');
    // var client = new MapboxClient('pk.eyJ1IjoiZW1lbGVuZGV6NyIsImEiOiJjajF6MGViMHkwMWJ4MzJrMmMwc3gxa2Z6In0.LO40SC_Jc4no9Bl360ZTkA');
    // client.getDirections(
    //   [
    //     { latitude:pickup_lat, longitude:pickup_lng },
    //     { latitude:drop_lat, longitude:drop_lng} ],
    //   function(err, res) {
    // var line_points2 = [];

    //     for(var route_map=0;route_map<res.routes[0].geometry.coordinates.length;route_map++){
    //       line_points2[route_map]=res.routes[0].geometry.coordinates[route_map];
    //        line_points2[route_map].reverse();
    //     }
    // var polyline_options = {
    //     color: '#2cff00',
    //      smoothFactor: 20.0
    // };
    // that.polyline = L.polyline(line_points2, polyline_options).addTo(that.map);

    // });
  }

  cancelBasedOnStatus() {
    console.log('cancelBasedOnStatus');
    if (this.showbooking_content.bookingStatus == 1 || (this.showbooking_content.bookingStatus == 2 && this.showbooking_content.unAssigned)) {
      this.beforeOrAfter = 1;
      this.cancelappt();
    } else {
      this.beforeOrAfter = 2;
      this.cancelApptAfterAccept();
    }
    // if (this.unasgnTab == 1) {
    //   this.beforeOrAfter = 2;
    //   this.cancelApptAfterAccept();
    // } else {
    //   this.beforeOrAfter = 1;
    //   this.cancelappt();
    // }
    // const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
    //   'rotate_pointer'
    // );
    // if (!isRightMarkerIsOpen) {
    //   jQuery('.right_marker').trigger('click');
    // }
  }

  customerCancelAfterAccept(data) {
    console.log('customerCancelAfterAccept');
    $('#body_' + data.bid).addClass('remove');
    // this.moveToPastAssigned(data);
    // this.getmyjobs(3)
    const indexofBooking = this.past_jobs.findIndex(
      i => i.bookingId == data.bid
    );
    // console.log('indexofBooking', indexofBooking);
    if (indexofBooking !== -1) {
      this.past_jobs.splice(indexofBooking, 1);
    } else {
      this.getmyjobs(1);
      this.getmyjobs(2);
    }

    this.passDetailsContent = '';
    this.showbooking_content = '';
  }

  beforeOrAfter = 1;
  // cancel booking after accepting
  cancelApptAfterAccept() {
    const reason = $('input[name="quality"]:checked').val();
    // this._dispatcherHomeService.cancelserviceAfterAccept({
    this._dispatcherHomeService
      .cancelservice({
        // "reason": reason,
        // "bookingId": this.cancellation_bid.toString(),
        reason: reason,
        bookingId: this.showbooking_content.bookingId.toString(),
        beforeOrAfter: this.beforeOrAfter,
        customerId: this.cancellationCustomerId
      })
      .subscribe(
        (res: any) => {
          $('#appcancel_rs').modal('hide');
          swal('Booking Cancelled!', 'Booking cancelled', 'success');
          $('#details_task').modal('hide');
          const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
            'rotate_pointer'
          );
          if (!isRightMarkerIsOpen) {
            jQuery('.right_marker').trigger('click');
          }
          // this.moveToPastAssigned();
          // this.passDetailsContent = "";
          // this.showbooking_content = "";
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  // cancel booking before accepting

  cancelappt() {
    console.log('cancelappt');
    const reason = $('input[name="quality"]:checked').val();
    this._dispatcherHomeService
      .cancelservice({
        reason: reason,
        bookingId: this.cancellation_bid
          ? this.cancellation_bid.toString()
          : this.showbooking_content.bookingId.toString(),
        beforeOrAfter: this.beforeOrAfter,
        customerId: this.cancellationCustomerId
      })
      .subscribe(
        (res: any) => {
          $('#appcancel_rs').modal('hide');
          swal('Booking Cancelled!', 'Booking cancelled', 'success');
          $('#details_task').modal('hide');
          const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
            'rotate_pointer'
          );
          if (!isRightMarkerIsOpen) {
            jQuery('.right_marker').trigger('click');
          }
          this.bookingCount();
          this.offers = this.offers.filter(
            booking => this.showbooking_content.bookingId != booking.bookingId
          );
          // this.moveToPast();
          this.passDetailsContent = '';
          this.showbooking_content = '';
          this.negotiations = [];
          this.old_negotiations = [];
          this.new_negotiations = [];
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }

  // move to past from offers

  moveToPast() {
    console.log('moveToPast', this.beforeOrAfter);
    $('#' + this.cancellation_bid).addClass('remove');
    const indexofBooking = this.offers.findIndex(
      i => i.bookingId == this.cancellation_bid
    );
    // console.log('indexofBooking', indexofBooking);
    // console.log('this.offers', this.offers);
    if (indexofBooking !== -1) {
      this.offers[indexofBooking].bookingStatus = 3;
      this.offers[indexofBooking].bookingStatusText = 'Request Cancelled';
      this.offers[indexofBooking].timeStamp.cancelled = moment().format(
        'Do MMMM YYYY, h:mm:ss a'
      );
      // this.past_jobs.splice(0, 0, this.offers[indexofBooking]);
      // this.unassignedCount--;
      // this.pastCount++;
      this.bookingCount();
    } else {
      // find booking in assigned jobs
      const index = this.past_jobs.findIndex(
        i => i.bookingId == this.cancellation_bid
      );
      // console.log('index', index);
      // console.log('this.past_jobs', this.past_jobs);
      if (index !== -1) {
        this.past_jobs[index].bookingStatus = 4;
        this.past_jobs[index].bookingStatusText = 'Request Cancelled';
        this.past_jobs[index].timeStamp.cancelled = moment().format(
          'Do MMMM YYYY, h:mm:ss a'
        );
        this.pastCount--;
      } else {
        // find booking in unassigned jobs
        const index1 = this.assigned_jobs.findIndex(
          i => i.bookingId == this.cancellation_bid
        );
        // console.log('index1', index1);
        // console.log('this.assigned_jobs', this.assigned_jobs);
        if (index1 !== -1) {
          this.assigned_jobs[index1].bookingStatus = 3;
          this.assigned_jobs[index1].bookingStatusText = 'Request Cancelled';
          this.assigned_jobs[index1].timeStamp.cancelled = moment().format(
            'Do MMMM YYYY, h:mm:ss a'
          );
          this.assignedCount--;
        } else {
          // find booking in unassigned jobs
        }
      }
    }
    setTimeout(() => {
      this.offers.splice(indexofBooking, 1);
    }, 1000);
  }

  // move to past from assinged
  moveToPastAssigned(data) {
    console.log('moveToPastAssigned');
    $('#body_' + data.bid).addClass('remove');
    // console.log(data.bid);
    const indexofBooking = this.past_jobs.findIndex(
      i => i.bookingId == data.bid
    );
    // console.log('indexofBooking', indexofBooking);
    if (indexofBooking !== -1) {
      this.past_jobs[indexofBooking].bookingStatus = data.status;
      this.past_jobs[indexofBooking].bookingStatusText = 'Request Cancelled';
      this.past_jobs[indexofBooking].timeStamp.cancelled = moment().format(
        'MMMM Do YYYY, h:mm:ss a'
      );
      // this.past_jobs.splice(0, 0, this.past_jobs[indexofBooking]);
      // this.assignedCount--;
      // this.pastCount--;
    } else {
      // find booking in assigned jobs
    }
    this.assigned_jobs.splice(indexofBooking, 1);
  }
  // onBlurMethod(){
  //    var that = this;
  //    var placeSearch, autocomplete;
  //   autocomplete = new google.maps.places.Autocomplete(
  //            (document.getElementById('pac-input2')),
  //           {types: ['geocode']});
  //           autocomplete.addListener('place_changed', function(){
  //             var place = autocomplete.getPlace();
  //             var marker_point = new L.Marker(new L.LatLng(place.geometry.location.lat(), place.geometry.location.lng()));
  //             that.map.addLayer(marker_point);
  //             that.map.setView([place.geometry.location.lat(), place.geometry.location.lng()], 13,{}
  //             );
  //             var fx = new L.PosAnimation();
  //             fx.run(marker_point, [300, 500], 0.5);
  //           });
  // }

  show_pickup(item) {
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    // console.log('this.map_loader', this.map_loader);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
  }

  show_negos_on_map(item) {
    // console.log(item);
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const markerIcon = {
      url: 'https://s3.amazonaws.com/uberfortruck/driver_bid_marker.svg',
      scaledSize: new google.maps.Size(60, 80),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(32, 65),
      labelOrigin: new google.maps.Point(30, 36)
    };
    const bounds_ = new google.maps.LatLngBounds();
    for (let inst = 0; inst < item.length; inst++) {
      const lat = item[inst].latLong.split(',');
      const position = new google.maps.LatLng(
        parseFloat(lat[0]),
        parseFloat(lat[1])
      );
      const markerLabel = item[inst].mPrice.toString();
      const marker = new google.maps.Marker({
        position: position,
        icon: markerIcon,
        map: this.map1,
        label: {
          text: markerLabel,
          color: '#fff',
          fontSize: '13px',
          fontWeight: 'bold'
        }
      });
      bounds_.extend(position);
      this.map1.fitBounds(bounds_);
      this.allroute_markers.push(marker);
    }
  }

  google_path(item) {
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const pos2 = new google.maps.LatLng(
      item.drop.location.latitude,
      item.drop.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker2);
    const directionsService2 = new google.maps.DirectionsService({
      preserveViewport: true
    });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: '#00ff5b' }
    });
    this.directionsDisplay.setMap(this.map1);
    const request = {
      origin: pos1, // LatLng|string
      destination: pos2, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };

    directionsService2.route(request, (response, status) => {
      if (status == 'OK') {
        // console.log(response);
        const point = response.routes[0].legs[0];
        let journey_time = point.distance.value;
        journey_time = journey_time / 1000;
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(
          this.map1,
          'bounds_changed',
          event => {
            if (journey_time <= 100) {
              this.map1.setZoom(12);
            } else if (journey_time > 100 && journey_time < 500) {
              this.map1.setZoom(8);
            } else if (journey_time > 500 && journey_time < 1500) {
              this.map1.setZoom(6);
            } else if (journey_time > 1500 && journey_time < 1000) {
              this.map1.setZoom(5);
            } else if (journey_time < 1000) {
              this.map1.setZoom(3);
            }
            google.maps.event.trigger(this.map1, 'resize');
          }
        );
        setTimeout(() => {
          google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000);

        this.directionsDisplay.setDirections(response);
      }
    });
  }

  counter_offer(item) {
    jQuery('#counterPrice').on('keypress', function () {
      const value = parseInt($(this).val());
      console.log('counter_offer', value);
      if (value <= 0) {
        $('#counterPriceYes').attr('disabled', true);
      } else {
        $('#counterPriceYes').attr('disabled', false);
      }
    });
    if (item._id == undefined) {
      item._id = item.id;
    }

    this.current_bid_item = item;
    this.dispatcherId = item.dispatcherId;
    if ($('.myoffer_blocks').hasClass('blink')) {
      $('.myoffer_blocks').removeClass('blink');
    }
    setTimeout(() => {
      $('#counter_popup').modal('show');
    }, 100);
  }

  call_counter_offer() {
    const biddingPrice = this.counter_price;
    this.map_loader = true;
    if (this.counter_price > 0) {
      this._dispatcherHomeService
        .counter_price({
          bookingId: this.negotiation_bid.toString(),
          driverId: this.current_bid_item.driverId,
          price: this.counter_price.toString(),
          status: 2,
          dispatcherId: this.dispatcherId
          // 'dispatcherId': '',
        })
        .subscribe(
          (res: any) => {
            console.log('call_counter_offer', res);
            $('#counter_popup').modal('hide');
            $(`#body_${this.negotiation_bid}`).trigger('click');
            // this.change_biding_status();
            this.map_loader = false;
            $('.modal-backdrop').hide();
            // const biddingData = {
            //   'bookingId': this.negotiation_bid.toString(),
            //   'offerPrice': biddingPrice
            // }
            // console.log(this.counter_price);
            // this.changeCustomerOffer(biddingData);
            // this.counter_price = '';
            swal(
              'Counter successful!',
              res.message,
              'success'
            );
          },
          err => {
            this.handleStatus(err.status, err.error);
          }
        );
    } else {
      this.map_loader = false;
      swal('Warning', 'Please Enter a Valid Counter', 'warning');
    }
  }

  // customer counter
  customer_counter(data) {
    // console.log('customer counter data', data);
    this.negotiation_bid = data.bookingId.toString();

    if (
      this.showbooking_content &&
      this.showbooking_content.bookingId == this.negotiation_bid
    ) {
      const index_newnegos = this.new_negotiations.findIndex(
        i => i.driverId == data.negotiation.driverId
      );
      const index_negos = this.negotiations.findIndex(
        i => i.driverId == data.negotiation.driverId
      );
      if (index_newnegos !== -1) {
        this.new_negotiations[index_newnegos].status = data.negotiation.status;
        this.new_negotiations[index_newnegos].offerPriceCustomer =
          data.negotiation.offerPriceCustomer;
        this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
        this.old_negotiations.push(this.new_negotiations[index_newnegos]);
        this.new_negotiations.splice(index_newnegos, 1);
        this.counter_price = '';
      }
      jQuery(`#${data.bookingId}`).trigger('click');
    }

    const biddingPrice = data.negotiation.offerPriceCustomer;
    const biddingData = {
      bookingId: this.negotiation_bid,
      offerPrice: biddingPrice
    };
    this.changeCustomerOffer(biddingData);
    this.counter_price = '';

    // const indexOfBooking = this.offers.findIndex(i => i.bookingId == parseInt(data.bookingId));
    // if (this.offers[indexOfBooking].negotiationData.bestBidCustomer < data.offerPrice) {
    //   this.offers[indexOfBooking].negotiationData.bestBidCustomer = data.offerPrice;
    // }

    // moving bid to past
    // if (this.showbooking_content.bookindId == this.negotiation_bid) {
    //   const index_newnegos = this.new_negotiations.findIndex(i => i.bookindId == this.negotiation_bid);
    //   const index_negos = this.negotiations.findIndex(i => i._id == data.negotiation.driverId);
    //   this.new_negotiations[index_newnegos].status = 104;
    //   this.new_negotiations[index_newnegos].aPrice = data.negotiation.offerPriceCustomer;
    //   this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
    //   this.old_negotiations.push(this.new_negotiations[index_newnegos]);
    //   this.new_negotiations.splice(index_newnegos, 1);
    // }
    // console.log('acceptoffer', this.new_negotiations);
    console.log('customer_counter', this.negotiations);
  }

  accept_offer(item) {
    $('#accept_popup').modal('show');
    this.accept_offer_details = item;
    console.log('acceptoffer', item);
  }

  change_biding_status() {
    if (this.showbooking_content.bookingId == this.negotiation_bid) {
      const index_newnegos = this.new_negotiations.findIndex(
        i => i.driverId == this.current_bid_item.driverId
      );
      const index_negos = this.negotiations.findIndex(
        i => i.driverId == this.current_bid_item.driverId
      );
      this.new_negotiations[index_newnegos].status = 103;
      this.new_negotiations[
        index_newnegos
      ].offerPriceCustomer = this.counter_price;
      this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
      this.old_negotiations.push(this.new_negotiations[index_newnegos]);
      this.new_negotiations.splice(index_newnegos, 1);
      this.counter_price = '';
      console.log('change_biding_status', this.negotiations);
    }
  }

  change_biding_to_past() {
    console.log('change_biding_to_past');
    if (this.showbooking_content.bookingId == this.negotiation_bid) {
      const index_newnegos = this.new_negotiations.findIndex(
        i => i.bookingId == this.accept_offer_details['bookingId']
      );
      const index_negos = this.negotiations.findIndex(
        i => i._id == this.accept_offer_details._id
      );
      this.new_negotiations[index_newnegos].status = 104;
      this.new_negotiations[index_newnegos].aPrice = this.new_negotiations[
        index_newnegos
      ].mPrice;
      this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
      this.old_negotiations.push(this.new_negotiations[index_newnegos]);
      this.new_negotiations.splice(index_newnegos, 1);
    }
  }
  get_negotitations(item) {
    if (item.dataForDispatcher.negotiation.length) {
      this.old_negotiations = [];
      this.new_negotiations = [];
      this.negotiations = [];
      this.negos_loader = true;
      this.negotiation_bid = item.dataForDispatcher.bookingId.toString();
      for (
        let inst = 0;
        inst < item.dataForDispatcher.negotiation.length;
        inst++
      ) {
        if (
          item.dataForDispatcher.negotiation[inst].status == 101 ||
          item.dataForDispatcher.negotiation[inst].status == 102
        ) {
          this.new_negotiations.push(item.dataForDispatcher.negotiation[inst]);
        } else {
          this.old_negotiations.push(item.dataForDispatcher.negotiation[inst]);
        }
        this.negotiations.push(item.dataForDispatcher.negotiation[inst]);
      }
      console.log(
        'get_negotitations',
        this.new_negotiations,
        this.old_negotiations,
        this.negotiations
      );
    }
    this.negos_loader = false;
  }

  showBiddingDriverMarkers(item) {
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const pos2 = new google.maps.LatLng(
      item.drop.location.latitude,
      item.drop.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
  }
  // show booking details including path and details in right hand slide

  bookingrequested(item) {
    this.showbooking_content = item;
    this.filtered_bid = item.bookingId;
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    if (isRightMarkerIsOpen) {
      jQuery('.right_marker').trigger('click');
    }
    $('.left_window_body .myoffer_blocks').removeClass('active'); // highlight active bid blcok
    $('#body_' + item.bookingId).addClass('active');
    this.negos_loader = true;
    console.log('bookingrequested', item);
    this.clearallpassdetails();
    setTimeout(() => {
      this.google_path(item);
    }, 1000);

    if (item.bookingStatus == 1 && item.negotiation.length == 0) {
      this.map_loader = true;
      this._dispatcherHomeService.getBookingDetails(item.bookingId).subscribe(
        (data: any) => {
          const a = this.offers.findIndex(
            offers => offers.bookingId == this.filtered_bid
          );
          if (a !== -1) {
            // console.log('Index-->', this.offers, a);
            this.offers[a] = data.dataForDispatcher;
            // this.offers.splice(a, 1, data.dataForDispatcher);
            // console.log('-->', this.offers[a]);
            this.offers[a].bookingDateTimestamp = moment
              .unix(this.offers[a].bookingDateTimestamp)
              .format('DD MMM  YYYY, hh : mm a');
            // this.offers[a].deliveryDateTimestamp = moment.unix(this.offers[a].deliveryDateTimestamp).format('DD MMM YYYY, hh : mm a');
            this.offers[a].timeStamp.created = moment(
              this.offers[a].timeStamp.created * 1000
            ).format('DD MMM YYYY, hh : mm a');
          } else {
            const unassIndex = this.assigned_jobs.findIndex(
              booking => booking.bookingId == this.filtered_bid
            );
            if (unassIndex !== -1) {
              this.assigned_jobs[unassIndex] = data.dataForDispatcher;
              this.assigned_jobs[unassIndex].bookingDateTimestamp = moment
                .unix(this.assigned_jobs[unassIndex].bookingDateTimestamp)
                .format('DD MMM  YYYY, hh : mm a');
              this.assigned_jobs[unassIndex].timeStamp.created = moment(
                this.assigned_jobs[unassIndex].timeStamp.created * 1000
              ).format('DD MMM YYYY, hh : mm a');
            }
          }
          // console.log(data);
          this.currentBookingID = data.dataForDispatcher.bookingId;
          this.loadPickupTime = data.data.pickupDate;
          this.showbooking_content = data.dataForDispatcher;
          this.get_negotitations(data);
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      ); // loader on
      // this.showbooking_content = item;                 // sending component details
      // $('.left_window_body .myoffer_blocks').removeClass('active');    // highlight active bid blcok
      $('#right_back_div').hide(); // remove all the right hand side blocks
      // if(this.unasgnTab == 2) {
      //   $("#right_back_div").hide();
      //   $("#right_back_div_unassign").show();
      // } else {
      //   $("#right_back_div_unassign").hide();
      //   $("#right_back_div").show();
      // }
      $('#right_back_div_unassign').show();
      $('#right_back_div').show();
    } else {
      this._dispatcherHomeService.getBookingDetails(item.bookingId).subscribe(
        (data: any) => {
          const a = this.offers.findIndex(
            offers => offers.bookingId == this.filtered_bid
          );
          if (a !== -1) {
            // console.log('Index-->', a, this.offers);
            this.offers[a] = data.dataForDispatcher;
            // this.offers.splice(a, 1, data.dataForDispatcher);
            this.offers[a] = data.dataForDispatcher;
            // console.log('-->', this.offers[a]);
            this.offers[a].bookingDateTimestamp = moment
              .unix(this.offers[a].bookingDateTimestamp)
              .format('DD MMM  YYYY, hh : mm a');
            // this.offers[a].deliveryDateTimestamp = moment.unix(this.offers[a].deliveryDateTimestamp).format('DD MMM YYYY, hh : mm a');
            this.offers[a].timeStamp.created = moment(
              this.offers[a].timeStamp.created * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          this.currentBookingID = data.dataForDispatcher.bookingId;
          this.loadPickupTime = data.data.pickupDate;
          this.showbooking_content = data.dataForDispatcher;
          item = data.dataForDispatcher;
          this.get_negotitations(data);
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
      // remove all the markers if defined
      this.show_pickup(item);

      // $('.left_window_body .myoffer_blocks').removeClass('active');    // highlight active bid blcok
      const bid = item.bookingId;
      $('#body_' + bid).removeClass('blink');
      // $('#body_' + bid).addClass('active');
      $('#right_back_div_unassign').show();
      $('#right_back_div').show();
      $('#right_front_div').hide();
      this.shownegos_content = item;
    }

    const ids = this.selected_vehicletype.toString();
    if (this.selected_vehicletype == undefined) {
      this.selected_vehicletype.toString();
    }
    if (this.filter == undefined || this.filter == '') {
      this.filter = '1';
    }
    if (this.sort == undefined || this.sort == '') {
      this.sort = '1';
    }
    if (this.unasgnTab == 2) {
      this._dispatcherHomeService
        .nearest_drivers({
          bookingId: item.bookingId.toString(),
          typeIds: ids,
          sortBy: this.filter.toString(),
          sortOrder: this.sort.toString(),
          search: this.search_driver_text,
          operatorDrivers: this.showOnlyOperatorDrivers ? '1' : '0'
        })
        .subscribe(
          (res: any) => {
            this.map_loader = false;
            this.filtered_drivers_total = [];
            this.filtered_drivers = [];
            this.filtered_drivers_offline = [];
            this.filtered_drivers_busy = [];
            this.driverArray = res.data.driverArray;
            this.vechiletypes = res.data.typesArray;
            this.selected_vehicletype = [];
            this.initialActiveDrivers = [];
            this.initialTotalDrivers = [];
            if (!res.data.driverArray.length) {
              // EMPTYING ALL THE ARRAYS IF NO DRIVERS ARE FOUND
              $('#loading_drivers_parent').hide();
            } else if (res.data.driverArray.length) {
              this.showOnlineDriversOnMap(res.data.driverArray);
              // SETTING ALL THE DRIVERS BASED ON THEIR STATUS
              if (this.showbooking_content.dispatched !== undefined) {
                for (
                  let inst = 0;
                  inst < this.showbooking_content.dispatched.length;
                  inst++
                ) {
                  this.dispatchedDriverIdArray.push(
                    this.showbooking_content.dispatched[inst].driverId
                  );
                }
              }

              for (let key = 0; key < res.data.driverArray.length; key++) {
                const index = this.dispatchedDriverIdArray.indexOf(
                  res.data.driverArray[key].id
                );
                if (index !== -1) {
                  res.data.driverArray[key]['dispatch_count'] = 1;
                } else {
                  res.data.driverArray[key]['dispatch_count'] = 0;
                }
                let time = res.data.driverArray[key].lastSeen; // TAKES LASTONLINE AND CONVERTS TO HUMAN READABLE FORMAT
                if (time > 60) {
                  if (time < 3600) {
                    time = time / 60;
                    time = time.toFixed(0);
                    res.data.driverArray[key].lastSeen = time + ' min ago';
                  } else if (time < 86400) {
                    time = time / 3600;
                    time = time.toFixed(0);
                    res.data.driverArray[key].lastSeen = time + ' hours ago';
                  } else if (time > 86400) {
                    time = time / 86400;
                    time = time.toFixed(0);
                    res.data.driverArray[key].lastSeen = time + ' days ago';
                  }
                } else {
                  res.data.driverArray[key].lastSeen = time + ' sec ago';
                }
                this.filtered_drivers_total.push(res.data.driverArray[key]);
                this.initialTotalDrivers.push(res.data.driverArray[key]);
                // console.log('Filtered total', this.filtered_drivers_total);                 // TOTAL DRIVERS PUSH IN TO AN ARRAY
                if (res.data.driverArray[key].status == 3) {
                  this.filtered_drivers.push(res.data.driverArray[key]);
                  this.initialActiveDrivers.push(res.data.driverArray[key]);
                  // ONLINE DRIVERS PUSH IN TO AN ARRAY
                  const pos2 = new google.maps.LatLng(
                    res.data.driverArray[key].location.latitude,
                    res.data.driverArray[key].location.longitude
                  );
                  const icon = {
                    url: res.data.driverArray[key].vehicleDetail.vehicleMapIcon, // url
                    scaledSize: new google.maps.Size(30, 30), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(0, 0) // anchor
                  };
                  const marker = new google.maps.Marker({
                    icon: icon,
                    position: pos2,
                    map: this.map,
                    animation: google.maps.Animation.DROP
                  });
                  marker.driverId = res.data.driverArray[key].id;
                  this.route_markers.push(marker);
                  // console.log('-------->', marker, this.route_markers);
                } else if (res.data.driverArray[key].status == 4) {
                  this.filtered_drivers_offline.push(res.data.driverArray[key]); // OFFLINE DRIVERS PUSH IN TO AN ARRAY
                } else if (res.data.driverArray[key].status == 5) {
                  this.filtered_drivers_busy.push(res.data.driverArray[key]); // BUSY DRIVERS PUSH IN TO AN ARRAY
                }
              }
            }
            // console.log('this.filtered_drivers', this.filtered_drivers);
          },
          err => {
            this.handleStatus(err.status, err.error);
          }
        );
    }
    setTimeout(() => {
      $('#body_' + item.bookingId).addClass('active');
    }, 750);
  }
  // show online drivers on map by vivek
  showOnlineDriversOnMap(data) {
    const onlineDrivers = data.filter(res => res.status == 3);
    console.log('Online drivers Show fun ', onlineDrivers);
    onlineDrivers.map(res => {
      const latLng = {
        lat: res.location.latitude,
        lng: res.location.longitude
      };
      const icon = {
        url: res.vehicleDetail.vehicleMapIcon, // url
        scaledSize: new google.maps.Size(30, 30), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(0, 0) // anchor
      };
      const marker = new google.maps.Marker({
        icon: icon,
        position: latLng,
        map: this.map1,
        title: res.name,
        animation: google.maps.Animation.DROP
      });
      this.route_markers.push(marker);
      marker.addListener('click', toggleBounce);
      function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => {
            marker.setAnimation(null);
          }, 2000);
        }
      }
    });
  }
  // assigned booking
  assingedBooking(item, id) {
    this.showbooking_content = item;
    console.log('dshdfvdfhvdfv ', this.showbooking_content)
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    if (isRightMarkerIsOpen) {
      jQuery('.right_marker').trigger('click');
    }
    //changeBookingStatus shiftBookingToTop
    // console.log(item);
    $('#body_' + item.bookingId).removeClass('blink');
    $("#body_" + item.bookingId).removeClass('emergency');
    $('.left_window_body .myoffer_blocks').removeClass('active');
    $(`#body_${item.bookingId}`).addClass('active');
    this.otp_entered = '';
    this._dispatcherHomeService.getBookingDetails(id, 2).subscribe(
      (data: any) => {
        // setTimeout(() => {
        //   data.dataForDispatcher.bookingStatus == 7 ? $('#otp_popup').modal('show') : '';
        // }, 1000)
        // console.log(data.dataForDispatcher);
        if (
          data.dataForDispatcher.bookingStatus !== 4 &&
          data.dataForDispatcher.bookingStatus !== 3 &&
          data.dataForDispatcher.bookingStatus !== 13
        ) {
          this.live_path_show(item);
        }
        this.loadPickupTime = data.data.bookingDate;
        this.showbooking_content = data.dataForDispatcher;
        if (this.showbooking_content.timeStamp.created !== '0') {
          this.showbooking_content.timeStamp.created = moment(
            this.showbooking_content.timeStamp.created * 1000
          ).format('DD MMM YYYY, hh mm a');
        }
      },
      err => {
        console.log(err);
        this.handleStatus(err.status, err.error);
      }
    );
    // if (item.bookingStatus !== 4 && item.bookingStatus !== 3 && item.bookingStatus !== 13) {
    //   this.live_path_show(item);
    // }
    this.show_live_path(item);
    // this.showbooking_content = item;
    $('#right_front_div').show();
    $('#right_back_div').hide();
  }
  show_live_path(item) {
    this.map_loader = true;
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const pos2 = new google.maps.LatLng(
      item.drop.location.latitude,
      item.drop.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.map1.setCenter({
      lat: item.pickup.location.latitude,
      lng: item.pickup.location.longitude
    });
    this.map1.setZoom(12);
    // this.showingVehicleMarker.setPosition(latlng);
    // move to current position by vivek
    // const gMap = new google.maps.Map(document.getElementById('map1'));
    // console.log(pos1, pos2, item.pickup.location.latitude, item.pickup.location.longitude, this.map1);
    // gMap.setZoom(14);      // This will trigger a zoom_changed on the map
    // gMap.setCenter(item.pickup.location.latitude, item.pickup.location.longitude);
    this.allroute_markers.push(marker2);
  }
  old_negos_div_show() {
    jQuery('.connections_div_all').hide();
    jQuery('#offline_drivers_div').show();
    jQuery('.negotiations_header_blocks').removeClass('active');
    jQuery('#offline_dri_head').addClass('active');
  }

  total_negos_div_show() {
    jQuery('.connections_div_all').hide();
    jQuery('#total_drivers_div').show();
    jQuery('.negotiations_header_blocks').removeClass('active');
    jQuery('#total_dri_head').addClass('active');
  }

  new_negos_div_show() {
    jQuery('.connections_div_all').hide();
    jQuery('#online_drivers_div').show();
    jQuery('.negotiations_header_blocks').removeClass('active');
    jQuery('#online_dri_head').addClass('active');
  }

  show_history(item) {
    if ($('.myoffer_blocks').hasClass('blink')) {
      $('.myoffer_blocks').removeClass('blink');
    }
    this.negos_history = [];
    console.log('historyItem', item);
    // $(".chat_history_block").hide();
    for (let inst = 0; inst < item.history.length; inst++) {
      item.history[inst].timeformat = moment
        .unix(item.history[inst].time)
        .format('DD MMM  YYYY, hh mm a');
      this.negos_history.push(item.history[inst]);
    }
    // if (!$('#' + this.showbooking_content.bookingId + '_' + item.status).hasClass('active')) {
    //   $('.chat_history_block').removeClass('active');
    //   $('#' + this.showbooking_content.bookingId + '_' + item.status).addClass('active');
    //   $('#' + this.showbooking_content.bookingId + '_' + item.status).slideToggle();
    // } else {
    //   $('.chat_history_block').removeClass('active');
    //   $('#' + this.showbooking_content.bookingId + '_' + item.status).slideToggle();
    // }
    if (
      !$(
        '#' +
        this.showbooking_content.bookingId +
        '_' +
        item.driverId +
        '_' +
        item.status
      ).hasClass('active')
    ) {
      $('.chat_history_block').removeClass('active');
      $(
        '#' +
        this.showbooking_content.bookingId +
        '_' +
        item.driverId +
        '_' +
        item.status
      ).addClass('active');
      $(
        '#' +
        this.showbooking_content.bookingId +
        '_' +
        item.driverId +
        '_' +
        item.status
      ).slideToggle();
    } else {
      $('.chat_history_block').removeClass('active');
      $(
        '#' +
        this.showbooking_content.bookingId +
        '_' +
        item.driverId +
        '_' +
        item.status
      ).slideToggle();
    }
  }

  customer_accepted(data) {
    // move to past
    console.log('2222', data);
    this.negotiation_bid = data.bookingId.toString();
    $(`#body_${data.bookingId}`).trigger('click');
    // $('#body_' + this.negotiation_bid).addClass('blink');
    // if (this.showbooking_content.bookindId == this.negotiation_bid) {
    //   if (this.accept_offer_details['handShakeDone'] == 0) {
    //     const index_newnegos = this.new_negotiations.findIndex(i => i.bookindId == this.negotiation_bid);
    //     const index_negos = this.negotiations.findIndex(i => i._id == data.negoitation.driverId);
    //     this.new_negotiations[index_newnegos].status = data.negoitation.status;
    //     this.new_negotiations[index_newnegos].aPrice = this.new_negotiations[index_newnegos].mPrice;
    //     this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
    //     this.old_negotiations.push(this.new_negotiations[index_newnegos]);
    //     this.new_negotiations.splice(index_newnegos, 1);
    //   }
    // }

    // handshake
    // if (this.accept_offer_details['handShakeDone'] == true) {
    console.log(
      'data.negotiation.handShake',
      data.negotiation['handShake'],
      data.negotiation.handShake
    );
    if (data.negotiation['handShake'] == 'false') {
      // alert('if part');
      console.log('this.new_negotiations', this.new_negotiations);
      console.log('this.old_negotiations', this.old_negotiations);

      const indexOfold = this.new_negotiations.findIndex(
        i => i.driverId == this.accept_offer_details.driverId
      );
      if (indexOfold != -1) {
        this.new_negotiations[indexOfold].status = 104;
        this.new_negotiations[indexOfold].time = 'a few seconds ago';
        this.old_negotiations.push(this.new_negotiations[indexOfold]);
        this.new_negotiations.splice(indexOfold, 1);
      }
    } else {
      // alert('else part');
      this.change_booking_assigned(data);
    }
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    (!isRightMarkerIsOpen) ?
      jQuery('.right_marker').trigger('click') : jQuery('.right_marker').trigger('click');
  }
  // dispatcherId = this._cookie.getItem('dispatcherId');
  accept_negotiation() {
    $('#body_' + this.negotiation_bid).removeClass('blink');
    this.map_loader = true;
    this._dispatcherHomeService
      .accept_price({
        bookingId: this.negotiation_bid,
        driverId: this.accept_offer_details.driverId,
        status: 2,
        dispatcherId: this.accept_offer_details['dispatcherId']
        // 'dispatcherId': '',
      })
      .subscribe(
        (res: any) => {
          this.map_loader = false;
          // this.change_biding_to_past();
          console.log('response', res);
          swal('Offer accepted!', '', 'success');
          $(`#body_${this.showbooking_content.bookingId}`).trigger('click');
          // handshakedone =  0 is meant for no one accepted the job
          // if (this.accept_offer_details['handShakeDone'] == 0) {
          //   console.log('this.new_negotiations', this.new_negotiations, this.accept_offer_details);
          //   const indexOfold = this.new_negotiations.findIndex(i => i.driverId == this.accept_offer_details.driverId);
          //   console.log(this.new_negotiations[indexOfold]);
          //   this.new_negotiations[indexOfold].status = 104;
          //   this.new_negotiations[indexOfold].time = "a few seconds ago";
          //   this.old_negotiations.push(this.new_negotiations[indexOfold]);
          //   this.new_negotiations.splice(indexOfold, 1);
          // } else {  // handshakedone =  1 is meant for some one accepted the job
          //   this.change_booking_assigned(this.showbooking_content);
          // }
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
  }
  changePosition(index, item) {
    // change the job position when driver counters
    console.log('index', index);
    console.log('item', item);
    const job = item;
    this.offers.splice(index, 1);
    this.offers.splice(0, 0, job);
  }

  driver_accepted(data) {
    // this.bookingCount();

    if (data.bookingType == 1) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        $('#details_task').modal('hide');
        // this.showbooking_content = [];
        const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
          'rotate_pointer'
        );
        if (!isRightMarkerIsOpen) {
          jQuery('.right_marker').trigger('click');
        }
      }
      this.getmyjobs(1);
      this.getmyjobs(3);
      return;
    }

    if (data.bookingType === 2) {
      // Find the job index to find the job
      const indexOfoldnegos = this.offers.findIndex(
        i => i.bookingId == data.bookingId
      );

      console.log('this.showbooking_content', this.showbooking_content);
      if (indexOfoldnegos !== -1) {
        setTimeout(() => {
          $('#body_' + data.bookingId).addClass('blink');
        }, 500);
        this.changePosition(indexOfoldnegos, this.offers[indexOfoldnegos]);
        if (this.showbooking_content !== undefined) {
          if (this.showbooking_content.bookingId == data.bookingId) {
            // if the booking showing and booking id coming in reponse are same
            const indexOfold = this.old_negotiations.findIndex(
              i => i.driverId == data.negotiation.driverId
            );
            if (indexOfold !== -1) {
              this.old_negotiations[indexOfold].offerPriceCustomer =
                data.negotiation.offerPriceCustomer;
              this.old_negotiations[indexOfold].offerPriceDriver =
                data.negotiation.offerPriceDriver;
              this.old_negotiations[indexOfold].status =
                data.negotiation.status;
              this.old_negotiations[indexOfold].time = 'a few seconds ago';
              this.old_negotiations[indexOfold].vehicleData.typeName =
                data.vehicle.typeName;
              this.old_negotiations[indexOfold].handShakeDone = 1;
              this.new_negotiations.push(this.old_negotiations[indexOfold]);
              this.old_negotiations.splice(indexOfold, 1);
              if (this.showbooking_content.negotiation == []) {
                this.old_negotiations[indexOfold].handShakeDone = 1;
                const indexofNewbooking = this.offers.findIndex(
                  i => i.bookingId == data.bookingId
                );
                this.offers[indexofNewbooking].negotiation.push(
                  this.old_negotiations[indexOfold]
                );
              }
            } else {
              // call single booking service to fetech vehilcle and driver details
              this.pushBidvalue(data);
              // this.new_negotiations.push(data.negotiation);
            }
          } else {
            // if the booking showing and reponse booking are different
            const indexOfold = this.offers.findIndex(
              i => i.bookingId == data.bookingId
            );
            if (this.offers[indexOfold].negotiation.length == 0) {
              this.offers[indexOfold].negotiationData.bestBidDriver =
                data.negotiation.offerPriceDriver;
              data.negotiation.handShakeDone = 1;
              this.offers[indexOfold].negotiation.push(data.negotiation);
            } else {
            }
          }
        } else {
          const indexOfold = this.offers.findIndex(
            i => i.bookingId == data.bookingId
          );
          if (this.offers[indexOfold].negotiation.length == 0) {
            data.negotiation.handShakeDone = 1;
            this.offers[indexOfold].negotiation.push(data.negotiation);
          }
          this.pushBidvalue(data);
        }
      } else {
        // call single booking api and push to offers array
      }
    }

    // for (let inst = 0; inst < this.offers.length; inst++) {
    //   if (this.offers[inst].id == data.bid) {
    //     $("#body_" + data.bid).addClass('blink');
    //     if (this.offers[inst].status == 1) {
    //       this.offers[inst].status = 2;
    //       this.offers[inst].negotiators = [data.id];
    //       this.changePosition(inst, this.offers[inst]);
    //     } else {
    //       if (this.showbooking_content.id == data.bid) {
    //         const showbooking = this.showbooking_content;
    //         let inside_booking = false;
    //         for (let negos = 0; negos < showbooking.negotiators.length; negos++) {
    //           if (showbooking.negotiators[negos] == data.id) {
    //             const indexOfoldnegos = this.old_negotiations.findIndex(i => i._id == data.id);
    //             if (indexOfoldnegos != -1) {
    //               inside_booking = true;
    //               this.old_negotiations[indexOfoldnegos].status = 101;
    //               this.old_negotiations[indexOfoldnegos].mPrice = data.mPrice;
    //               this.old_negotiations[indexOfoldnegos].aPrice = data.aPrice;
    //               this.old_negotiations[indexOfoldnegos].time = "a few seconds ago";
    //               this.new_negotiations.push(this.old_negotiations[indexOfoldnegos]);
    //               const index_negos = this.negotiations.findIndex(i => i._id == this.current_bid_item._id);
    //               this.negotiations[index_negos] = this.old_negotiations[indexOfoldnegos];
    //               this.old_negotiations.splice(indexOfoldnegos, 1);
    //             } else {
    //               console.log("not in the offers length");
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
  }

  // pushBid value to show in the left side and change the no of offers on leftside
  pushBidvalue(data) {
    // get index of booking in offers array
    const indexOfBooking = this.offers.findIndex(
      i => i.bookingId == data.bookingId
    );
    // checks with current bestbid value if its 0 then push response value
    // else compare if its less change the best bid driver value
    if (this.offers[indexOfBooking].negotiationData.bestBidDriver !== 0) {
      if (
        this.offers[indexOfBooking].negotiationData.bestBidDriver >
        data.negotiation.offerPriceDriver
      ) {
        this.offers[indexOfBooking].negotiationData.bestBidDriver =
          data.negotiation.offerPriceDriver;
      }
    } else {
      this.offers[indexOfBooking].negotiationData.bestBidDriver =
        data.negotiation.offerPriceDriver;
    }
    // checks if repsonse driver id in the negotiations array and change the value to show ->
    // no of offers on the leftside tab
    const indexofnegos = this.offers[indexOfBooking].negotiation.findIndex(
      i => i.driverId == data.negotiation.driverId
    );
    if (indexofnegos == -1) {
      this.offers[indexOfBooking].negotiation.push(data.negotiation);
    } else {
      // none of the booking ID is selected dont change the values in negorition array
    }
  }

  // changes best bid of the driver
  changeBestvalue(data) {
    // get index of booking in offers array
    const indexOfBooking = this.offers.findIndex(
      i => i.bookingId == data.bookingId
    );
    // checks with current bestbid value if its 0 then push response value
    // else compare if its less change the best bid driver value
    if (this.offers[indexOfBooking].negotiationData.bestBidDriver != 0) {
      if (
        this.offers[indexOfBooking].negotiationData.bestBidDriver >
        data.negotiation.offerPriceDriver
      ) {
        this.offers[indexOfBooking].negotiationData.bestBidDriver =
          data.negotiation.offerPriceDriver;
      }
    } else {
      this.offers[indexOfBooking].negotiationData.bestBidDriver =
        data.negotiation.offerPriceDriver;
    }
  }

  changeCustomerOffer(data) {
    // console.log('data', data.bookingId);
    // get index of booking in offers array
    const indexOfBooking = this.offers.findIndex(
      i => i.bookingId == parseInt(data.bookingId)
    );
    // console.log('data', indexOfBooking);
    // console.log('data', this.offers[indexOfBooking].negotiationData.bestBidCustomer);
    // checks with current bestbid value if its 0 then push response value
    // else compare if its less change the best bid driver value
    if (
      this.offers[indexOfBooking].negotiationData.bestBidCustomer <
      data.offerPrice
    ) {
      this.offers[indexOfBooking].negotiationData.bestBidCustomer =
        data.offerPrice;
    }
  }

  // driver counter
  driver_counter(data) {
    if (this.showbooking_content && this.showbooking_content.bookingId == data.bookingId) {
      $(`#${data.bookingId}`).trigger('click');
    }
    if (
      data.negotiation.dispatcherId != '' ||
      data.negotiation.dispatcherId != undefined
    ) {
      this.dispatcherId = data.negotiation.dispatcherId;
    }
    // triggers when drivers send a booking bid
    data.status = 1; // loop offers length to find the job
    const indexOfoldnegos = this.offers.findIndex(
      i => i.bookingId == data.bookingId
    );
    if (indexOfoldnegos !== -1) {
      // if the bookingid from response in the offers array
      if (
        this.showbooking_content !== undefined &&
        this.showbooking_content !== ''
      ) {
        // if the booking is currently clicked or showing
        if (this.showbooking_content.bookingId == data.bookingId) {
          const indexOfold = this.old_negotiations.findIndex(
            i => i.driverId == data.negotiation.driverId
          );
          if (indexOfold !== -1) {
            // booking is in view and change the negotiations past to new
            // change the value of last best driver bid
            this.changeBestvalue(data);
            this.old_negotiations[indexOfold].offerPriceCustomer =
              data.negotiation.offerPriceCustomer;
            this.old_negotiations[indexOfold].offerPriceDriver =
              data.negotiation.offerPriceDriver;
            this.old_negotiations[indexOfold].status = data.negotiation.status;
            this.old_negotiations[indexOfold].time = 'a few seconds ago';
            if (data.vehicle && data.vehicle != undefined) {
              this.old_negotiations[indexOfold].vehicleData.typeName =
                data.vehicle.typeName;
            }
            this.new_negotiations.push(this.old_negotiations[indexOfold]);
            this.old_negotiations.splice(indexOfold, 1);
            console.log(
              'driver counter 1--->>> ',
              data,
              this.showbooking_content,
              this.new_negotiations,
              this.old_negotiations
            );
          } else {
            // push new negotitaion in to an empty array or not found
            const indexOfBooking = this.offers.findIndex(
              i => i.bookingId == data.bookingId
            );
            this.changeBestvalue(data);
            this.offers[indexOfBooking].negotiation.push(data.negotiation);
            console.log(
              'driver counter 2--->>> ',
              this.new_negotiations,
              this.old_negotiations
            );
          }
        } else {
          // some booking is in view but not the same which reponses comes
          // just push negotitaion and change the last bid value
          this.pushBidvalue(data);
          console.log(
            'driver counter 3--->>> ',
            this.new_negotiations,
            this.old_negotiations
          );
        }
      } else {
        // none of the offers are selected and push the negoitation in to array change postion
        this.pushBidvalue(data);
        console.log(
          'driver counter 4--->>> ',
          this.new_negotiations,
          this.old_negotiations
        );
      }
      this.changePosition(indexOfoldnegos, this.offers[indexOfoldnegos]);
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 1000);
    } else {
      // call single booking service to get and push to offers array
    }
  }

  // if (this.offers[inst].status == 1) {   // checks for first time biding if yes send driver's bid to the job
  //     this.offers[inst].status = 2;
  //     this.offers[inst].negotiators = [data.id];
  //     this.changePosition(inst, this.offers[inst]);
  //     break;
  // }
  // else {
  //   // if negotiation is there then else excutes
  //   if (this.showbooking_content.id == data.bid) {
  //     const showbooking = this.showbooking_content;
  //     let inside_booking = false;
  //     if (showbooking.negotiators != undefined) {
  //       console.log('instl');
  //       for (let inst = 0; inst < showbooking.negotiators.length; inst++) {
  //         if (showbooking.negotiators[inst] == data.id) {
  //           const indexOfoldnegos = this.old_negotiations.findIndex(i => i._id == data.id);
  //           if (indexOfoldnegos != -1) {
  //             inside_booking = true;
  //             this.old_negotiations[indexOfoldnegos].status = 102;
  //             this.old_negotiations[indexOfoldnegos].mPrice = data.mPrice;
  //             this.old_negotiations[indexOfoldnegos].aPrice = data.aPrice;
  //             this.old_negotiations[indexOfoldnegos].time = "a few seconds ago";
  //             this.new_negotiations.push(this.old_negotiations[indexOfoldnegos]);
  //             const index_negos = this.negotiations.findIndex(i => i._id == this.current_bid_item._id);
  //             this.negotiations[index_negos] = this.old_negotiations[indexOfoldnegos];
  //             this.old_negotiations.splice(indexOfoldnegos, 1);
  //             console.log("this.new_negotiations1", this.new_negotiations);
  //           }
  //           else {
  //             this.showbooking_content.negotiator.push(data.id)
  //             inside_booking = true;
  //             this.negotiations.push(data);
  //             this.new_negotiations.push(data);
  //             console.log("this.new_negotiations2", this.new_negotiations);
  //           }
  //           this.changePosition(inst, this.offers[inst]);
  //           break;
  //         }
  //       }
  //       if (!inside_booking) {
  //         console.log("this.showbooking_content.negotiators", this.showbooking_content.negotiators);
  //         this.showbooking_content.negotiators.push(data.id);
  //         console.log("this.showbooking_content.negotiators_after", this.showbooking_content.negotiators);
  //         this.negotiations.push(data);
  //         this.new_negotiations.push(data);
  //         this.changePosition(inst, this.offers[inst]);
  //         console.log("this.new_negotiations3", this.new_negotiations);
  //       }
  //     }
  //     else {
  //       console.log('installed');
  //       this.offers[inst].negotiators = [data.id];
  //       this.offers[inst].lastNegotiationPrice = data.mPrice;
  //       this.changePosition(inst, this.offers[inst]);
  //       const indexOfoldnegos = this.old_negotiations.findIndex(i => i._id == data.id);
  //       if (indexOfoldnegos != -1) {
  //         this.old_negotiations[indexOfoldnegos].status = 102;
  //         this.old_negotiations[indexOfoldnegos].mPrice = data.mPrice;
  //         this.old_negotiations[indexOfoldnegos].aPrice = data.aPrice;
  //         this.old_negotiations[indexOfoldnegos].time = "a few seconds ago";
  //         this.new_negotiations.push(this.old_negotiations[indexOfoldnegos]);
  //         const index_negos = this.negotiations.findIndex(i => i._id == this.current_bid_item._id);
  //         this.negotiations[index_negos] = this.old_negotiations[indexOfoldnegos];
  //         this.old_negotiations.splice(indexOfoldnegos, 1);
  //         console.log("this.new_negotiations1", this.new_negotiations);
  //       }
  //       console.log(this.old_negotiations);
  //     }
  //   }

  //   break;
  // }

  new_job(data) {
    const indexOfBooking = this.offers.findIndex(
      booking => booking.bookingId == data.bookingId
    );
    $(`#body_${data.bookingId}`).trigger('click');
    this.map_loader = false;
    console.log('newJob', indexOfBooking, data);
    if (indexOfBooking !== -1) {
      return;
    }
    this._dispatcherHomeService
      .negotiations({
        bookingId: data.bookingId,
        status: 3
      })
      .subscribe(
        (res: any) => {
          console.log('newBooking', res);
          // if (res.data.pickupDate != "0") {
          //   res.data.pickupDate = moment.unix(res.data.pickupDate).format("DD MMM  YYYY, hh mm ss a");
          // }
          // if (res.data.dropDate != "0") {
          //   res.data.dropDate = moment.unix(res.data.dropDate).format("DD MMM YYYY, hh mm a");
          // }
          // if (res.data.postedOn != "0") {
          //   res.data.postedOn = moment(res.data.postedOn).format("DD MMM YYYY, hh mm a");
          // }
          if (res.dataForDispatcher.bookingDateTimestamp !== '0') {
            res.dataForDispatcher.bookingDateTimestamp = moment
              .unix(res.dataForDispatcher.bookingDateTimestamp)
              .format('DD MMM  YYYY, hh mm a');
          }
          // if (res.dataForDispatcher.deliveryDateTimestamp !== '0') {
          //   res.dataForDispatcher.deliveryDateTimestamp = moment.unix(res.dataForDispatcher.deliveryDateTimestamp).format('DD MMM YYYY, hh mm a');
          // }
          if (res.dataForDispatcher.timeStamp.created !== '0') {
            res.dataForDispatcher.timeStamp.created = moment(
              res.dataForDispatcher.timeStamp.created * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (res.dataForDispatcher.activities !== undefined) {
            for (
              let bookingstatus = 0;
              bookingstatus < res.dataForDispatcher.activities.length;
              bookingstatus++
            ) {
              res.dataForDispatcher.activities[
                bookingstatus
              ].timeConverted = moment(
                res.dataForDispatcher.activities[bookingstatus].time
              ).format('DD MMM YYYY, hh mm a');
            }
          }
          // console.log('before push', this.offers);
          // this.unassignedCount++;
          // FIXME:

          if (res.dataForDispatcher.unAssigned) {
            this.assigned_jobs.splice(0, 0, res.dataForDispatcher);
            this.assigned_jobs = uniqBy(this.assigned_jobs, 'bookingId');
          } else {
            this.offers.splice(0, 0, res.dataForDispatcher);
            this.offers = uniqBy(this.offers, 'bookingId');
            this.showTimer(res.dataForDispatcher);
          }
          // console.log('after push', this.offers);
          // setTimeout(function () {
          //   $('#body_' + res.dataForDispatcher.bookingId).addClass('blink_finite');
          // }, 1000);
          // this.bookingCount();
        },
        err => {
          this.map_loader = false;
          this.handleStatus(err.status, err.error);
        }
      );
  }

  change_booking_assigned(data) {
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    // console.log('data------->', this.accept_offer_details);
    if (data == undefined || data == '') {
      const bookingData = {
        bookingId: this.negotiation_bid
      };
      data = bookingData;
    }
    console.log('change_booking_assigned', data);
    // console.log('this.showbooking_content', this.showbooking_content);
    // console.log('data', data);
    if (data.negotiation && data.negotiation['handShake'] == 'true') {
      $('#' + data.bookingId).addClass('remove');
    } else {
      $('#' + data.bookingId).addClass('remove');
      this.getmyjobs(1);
      this.getmyjobs(2);
      this.getmyjobs(3);
      if (this.showbooking_content && this.showbooking_content.bookingId == data.bookingId) {
        (!isRightMarkerIsOpen) ? jQuery('.right_marker').trigger('click') : jQuery('.right_marker').trigger('click');
        // this.showbooking_content = [];
        this.old_negotiations = [];
        this.new_negotiations = [];
        this.negotiations = [];
        this.current_bid_item = undefined;
      }
      return;
    }
    if (this.showbooking_content && this.showbooking_content.bookingId == data.bookingId) {
      (!isRightMarkerIsOpen) ? jQuery('.right_marker').trigger('click') : jQuery('.right_marker').trigger('click');
      // jQuery('.right_marker').trigger('click');
      // this.showbooking_content = [];
      this.old_negotiations = [];
      this.new_negotiations = [];
      this.negotiations = [];
      this.current_bid_item = undefined;
    }
    // (!isRightMarkerIsOpen) ? jQuery('.right_marker').trigger('click') : jQuery('.right_marker').trigger('click');
    this.getmyjobs(1);
    this.getmyjobs(2);
    this.getmyjobs(3);
    // console.log('this.offers,', this.offers);
  }

  bookingCount(date = ['', '']) {
    this._dispatcherHomeService
      .getBookingCounter({
        status: '',
        fromDate: date[0],
        toDate: date[1],
        search: '',
        cityId: this._cookie.getCityId('cityid')
      })
      .subscribe(
        (res: any) => {
          // console.log('counterNumbers--------------->', res);
          this.unassignedCount = res.data.loadboard;

          this.assignedCount = res.data.unassigned;
          this.pastCount = res.data.assigned;
          $(`.numbers.font-allerta`)
            .addClass('animated flipInX')
            .one('animationend', function () {
              $(this).removeClass('animated flipInX');
            });
        },
        err => {
          this.map_loader = false;
          this.handleStatus(err.status, err.error);
        }
      );
  }

  booknow() {
    $('.booking_buutns').trigger('click');
  }

  // rating popup
  comments: any;
  rating = 0;
  ratingcomments(val) {
    this._dispatcherHomeService.getratings({}).subscribe((res: any) => {
      this.rating = val;
      switch (val) {
        case 1:
          this.comments = res.data.rating1;
          break;
        case 2:
          this.comments = res.data.rating2;
          break;
        case 3:
          this.comments = res.data.rating3;
          break;
        case 4:
          this.comments = res.data.rating4;
          break;
        case 5:
          this.comments = res.data.rating5;
          break;
      }
    });
  }
  rating_text = [];
  high_rating = [];
  show_low_rating: Boolean = false;
  show_high_rating: any;
  driver_rating: any;
  show_raing_txt(rate) {
    $('input[name=selector_review]').val(
      $('input[name=selector_review] option:first').val()
    );
    this.high_rating = [];
    this.rating_text = [];
    this.show_low_rating = true;
    this.ratingcomments(rate);
    this.show_high_rating = false;
    for (const key in this.driver_rating) {
      if (key == rate) {
        this.rating_text = this.driver_rating[key];
        break;
      }
    }
  }

  // submit review and reting
  submitReivew() {
    // submit review
    if (this.rating == undefined) {
      swal('Warning', 'Please give the rating & review!', 'warning');
      // this.comment_error = true;
    } else {
      const comment = $('#review_content').val();
      const review = $('input[name=cb]:checked').val();
      this.submitreview_call(comment, review);
    }
  }

  addhigh_reviews(text) {
    const indexofReview = this.high_rating.findIndex(i => i == text);
    if (indexofReview == -1) {
      this.high_rating.push(text);
    } else {
      this.high_rating.splice(indexofReview, 1);
    }
  }

  submitreview_call(comment, review) {
    $('.appt_loader_parent').show();
    // var bid = this.rating_b_details["bid"];
    const bid = this.pending_review[0].bookingId;
    this._dispatcherHomeService
      .postreview({
        bookingId: bid.toString(),
        rating: this.rating,
        review: this.high_rating.toString()
      })
      .subscribe((res: any) => {
        $('#review_popup').modal('hide');
        $('.appt_loader_parent').hide();
        this.rating = 0;
        this.high_rating = [];
        // this.comments = this.pending_reviews();
      });
  }

  pendingDriverId: any;
  pending_review = [];

  updateDriverImage(event) {
    event.target.src = myGlobals.driverImg;
  }

  updateVehicleImage(event) {
    event.target.src = myGlobals.vehicleicn;
  }

  currentlat() {
    if (navigator.geolocation) {
      const options: PositionOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };
      const success: PositionCallback = pos => {
        console.log(pos);
        const crd = pos.coords;
        this.current_lat = crd.latitude;
        this.current_lng = crd.longitude;
      };
      const error: PositionErrorCallback = err => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        const positionData = JSON.parse(this._cookie.getConfig('ipinfo'));
        // const positionData = JSON.parse(sessionStorage.getItem('ipinfo'));
        this.current_lat = positionData.latitude;
        this.current_lng = positionData.longitude;
      };
      navigator.geolocation.getCurrentPosition(success, error, options);
    } else {
      const positionData = JSON.parse(this._cookie.getConfig('ipinfo'));
      // const positionData = JSON.parse(sessionStorage.getItem('ipinfo'));
      this.current_lat = positionData.latitude;
      this.current_lng = positionData.longitude;
    }
  }

  loadMap() {
    console.warn('loadMap', typeof google);
    if (typeof google === 'undefined') {
      setTimeout(() => {
        this.loadMap();
      }, 1500);
      return;
    }
    this.current_lat = -28.4793;
    this.current_lng = 24.6727;
    const map = new google.maps.Map(document.getElementById('mapP'), {
      center: new google.maps.LatLng(
        this.current_lat ? this.current_lat : 12.9716,
        this.current_lng ? this.current_lng : 77.5946
      ),
      zoom: 18,
      minZoom: 1,
      styles: mapStyle[0],
      disableDefaultUI: true
      // zoomControl: true
    });
    this.map1 = map;

    const position_marker = new google.maps.LatLng(
      this.current_lat,
      this.current_lng
    );
    this.current_location_marker = new google.maps.Marker({
      position: position_marker,
      icon: myGlobals.currenticn,
      map: map
      // scaledSize: new google.maps.Size(50, 50),
      // origin: new google.maps.Point(0, 0),
      // anchor: new google.maps.Point(0, 0)
    });

    const controlDiv = document.getElementById('locateMe');
    controlDiv.addEventListener('click', () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            // console.log(position);
            const latlng = new google.maps.LatLng(
              position.coords.latitude,
              position.coords.longitude
            );
            this.current_location_marker.setPosition(latlng);
            this.map1.panTo(latlng);
            this.map1.setZoom(5);
          },
          err => {
            console.log(err);
            swal(
              'Warning',
              'Your Browser Does Not Support Geo-Location',
              'warning'
            );
          }
        );
      }
    });
    this.allroute_markers.push(this.current_location_marker);
    map.setCenter(position_marker);
    map.setZoom(5);

    this.map1.setOptions({
      minZoom: 2,
      maxZoom: 40
    });
  }

  ngOnInit() {
    this.currentlat();
    this.subscription = this._communicate
      .getCityChange()
      .subscribe(message => this.changeMapView(message));
    toastr.options = {
      // toast messages settings
      closeButton: true,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '8000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };
    // search booking by vivek
    flatpickr('.flatpickr7', {
      mode: 'range',
      maxDate: moment().format('YYYY-MM-DD'),
      dateFormat: 'Y-m-d',
      onChange: (selectedDates, dateStr, instance) => {
        const dates = dateStr.split(' ');
        if (dates.length == 3) {
          this.picker_date = moment(dates[0]).format('YYYY-MM-DD');
          this.drop_date = moment(dates[2]).format('YYYY-MM-DD');
        } else {
          this.picker_date = '';
          this.drop_date = '';
        }
      }
    });
    // this.unasgnTab = 1 => past_jobs, 0 => offers, 2 => unassigned
    jQuery('#search_picker').click(() => {
      // console.log('search');
      let tab;
      if (this.unasgnTab == 0) {
        tab = 1;
      } else if (this.unasgnTab == 2) {
        tab = 2;
      } else if (this.unasgnTab == 1) {
        tab = 3;
      }
      if (this.picker_date && this.drop_date) {
        this.bookingCount([this.picker_date, this.drop_date]);
        this.getmyjobs(tab);
      } else {
        swal('Warning', 'Please Select Vaild Range', 'warning');
      }
      // this.data2 = [];
      // this.data1 = [];
      // this.data3 = [];
      // this.picker_bool = true;
    });
    jQuery('#refresh_picker').click(() => {
      this.picker_date = '';
      this.drop_date = '';
      console.log('reset');
      $('.flatpickr7').val('');
      flatpickr('.flatpickr7').destroy();
      // search booking by vivek
      flatpickr('.flatpickr7', {
        mode: 'range',
        maxDate: moment().format('YYYY-MM-DD'),
        dateFormat: 'Y-m-d',
        onChange: (selectedDates, dateStr, instance) => {
          const dates = dateStr.split(' ');
          if (dates.length == 3) {
            this.picker_date = moment(dates[0]).format('YYYY-MM-DD');
            this.drop_date = moment(dates[2]).format('YYYY-MM-DD');
          } else {
            this.picker_date = '';
            this.drop_date = '';
          }
        }
      });
      this.bookingCount();
      let tab;
      if (this.unasgnTab == 0) {
        tab = 1;
      } else if (this.unasgnTab == 2) {
        tab = 2;
      } else if (this.unasgnTab == 1) {
        tab = 3;
      }
      this.getmyjobs(tab);
    });
    this.bookingCount();
    this.getmyjobs(1);
    this.getmyjobs(2);
    this.getmyjobs(3);
    this.currency = sessionStorage.getItem('currency');
    $('#newload').hide();
    setTimeout(() => {
      this.loadMap();
    }, 500);

    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    if (!isRightMarkerIsOpen) {
      jQuery('.right_marker').trigger('click');
    }
    $('#load_more').click(() => {
      this.page_index++;
    });
    $('#load_more').mouseover(function () {
      $('.more_tooltip').show();
    });
    $('#load_more').mouseout(function () {
      $('.more_tooltip').hide();
    });

    // DETAIL POPUP HIDE AND SHOW
    $('.details_description2').hide();
    $('.details_description3').hide();
    // FILTER TOOGLE ANIMATION

    $('#floating_button_body').hide();
    $('#floating_button').click(function () {
      $('#floating_button_body').toggle(function () {
        $('#floating_button_body').animate({
          height: 'auto'
        });
      });
    });

    // DATE FILTER FOR FILTERING ASSIGNED AND UNASSIGNED TASKS
    $('#header_date_picker').change(() => { });
    // END OF DATE FILTER FOR FILTERING ASSIGNED AND UNASSIGNED TASKS

    $('#hidden_btn').click(() => {
      this.data2 = [];
      this.data1 = [];
      this.data3 = [];
    });

    this.fname_b = localStorage.getItem('fname');
    this.fmail_b = localStorage.getItem('emailId');
    this.fphone_b = localStorage.getItem('cust_phone');

    jQuery('.phone_num_valid').keyup(function () {
      this.value = this.value.replace(/[^0-9\.]/g, '');
    });

    $('.vehicletypes_but').on('click', 'li', function () {
      $('.btn:first-child').text($(this).text());
      $('.btn:first-child').val($(this).text());
      this.vechicle_type = $(this).attr('id');
      localStorage.setItem('vechileType', this.vechicle_type);
    });

    $('#wght_value, #biding_price input').keypress(function (event) {
      const $this = $(this);
      if (
        (event.which !== 46 || $this.val().indexOf('.') !== -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which !== 0 && event.which !== 8))
      ) {
        event.preventDefault();
      }

      const text = $(this).val();
      if (event.which == 46 && text.indexOf('.') == -1) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if (
        text.indexOf('.') !== -1 &&
        text.substring(text.indexOf('.')).length > 2 &&
        (event.which !== 0 && event.which !== 8) &&
        $(this)[0].selectionStart >= text.length - 2
      ) {
        event.preventDefault();
      }
    });

    $('#add_popup_but').click(function () {
      // $("#contact-form").valid();
    });

    // $("#credit_card_popup").modal("show");

    $(function () {
      $(document.body).on('show.bs.modal', function () {
        $(document.body).addClass('modal-open');
      });
      $(document.body).on('hide.bs.modal', function () {
        $(document.body).removeClass('modal-open');
      });
    });

    jQuery('#back_button').hide();
    // jQuery('#right_back_div').hide();
    jQuery('#right_front_div').show();
    jQuery('.front_div_close').click(function () {
      // jQuery('#right_back_div').toggle();
      // jQuery('#right_front_div').hide();
    });
    jQuery('#right_taks_but').click(function () {
      jQuery('.tasks_list_right').toggle();
    });

    jQuery('.connections_div').click(function () {
      // jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').show();
    });

    jQuery('#path_history_button').click(() => {
      jQuery('.tabs_details').hide();
      jQuery('.path_history').show();
      jQuery('.details_but_sytle').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('#job_details_button').click(function () {
      jQuery('.tabs_details').hide();
      jQuery('.details_description').show();
      jQuery('.details_but_sytle').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('#activity_timeline_button').click(function () {
      jQuery('.tabs_details').hide();
      jQuery('.activity_timeline').show();
      jQuery('.details_but_sytle').removeClass('active');
      jQuery(this).addClass('active');
    });

    $('ul.details_popup_menu').on(
      'click',
      '#activity_timeline_button',
      function () { }
    );

    jQuery('#job_details_button').trigger('click');
    jQuery('#bulk_import_but').click(function () {
      jQuery('#bulk_import_but')
        .find('span')
        .toggleClass('active');
    });

    $('#assigned_but').click(() => {
      this.getmyjobs(1);
      this.bookingCount();
      const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
        'rotate_pointer'
      );
      if (!isRightMarkerIsOpen) {
        jQuery('.right_marker').trigger('click');
      }
      this.unassgnBooking = true;
      this.unasgnTab = 0;
      $('.common_tasks').hide();
      $('.assigned_jobs').show();
      this.clearallpassdetails();
    });
    $('#un_assigned_but').click(() => {
      this.getmyjobs(2);
      this.bookingCount();
      const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
        'rotate_pointer'
      );
      if (!isRightMarkerIsOpen) {
        jQuery('.right_marker').trigger('click');
      }
      this.unasgnTab = 2;
      this.moveLoadboard = true;
      $('.common_tasks').hide();
      $('.un_assigned_jobs').show();
      this.clearallpassdetails();
    });
    $('#completed_but').click(() => {
      this.bookingCount();
      this.getmyjobs(3);
      const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
        'rotate_pointer'
      );
      if (!isRightMarkerIsOpen) {
        jQuery('.right_marker').trigger('click');
      }
      this.unasgnTab = 1;
      this.unassgnBooking = true;
      $('.common_tasks').hide();
      $('.completed_jobs').show();
      this.clearallpassdetails();
    });

    jQuery('.width_3').click(function () {
      jQuery('.width_3').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('.width_3_rt').click(function () {
      jQuery('.width_3_rt').removeClass('active');
      jQuery(this).addClass('active');
    });

    $('.assigned_jobs').scroll(() => {
      const height = $('.assigned_jobs').prop('scrollHeight');
      const current = $('.assigned_jobs').scrollTop();
      const bottom = height * 0.8;
      // console.log('reached', current);
      // console.log('bottom', bottom);
      if (current > bottom && !this.offers_incall) {
        this.offers_skip = this.offers_skip + this.offers_limit;
        this.offers_incall = true;
        // this.getslaveappointments();
      }
    });

    // This example requires the Places library. Include the libraries=places
    // parameter when you first load the API. For example:
    // <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
  }
  refresh_all_fil() {
    this.data2 = [];
    this.data1 = [];
    this.data3 = [];
    this.picker_bool = false;
  }
  clearallpassdetails() {
    this.route_markers.map(res => {
      res.setMap(null);
    });
    this.passDetailsContent = '';
    this.showbooking_content = '';
    this.new_negotiations = [];
    this.old_negotiations = [];
    this.negotiations = [];
    this.shownegos_content = '';
    if (this.allroute_markers.length > 0) {
      for (let inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setVisible(false);
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
      //   this.directionsDisplay.setMap(null);
    }
    if (this.showingVehicleMarker !== undefined) {
      this.showingVehicleMarker.setMap(null);
      this.showingVehicleMarker = undefined;
    }

    if (this.pathline || this.pathline != undefined) {
      // this.pathline.setMap(null);
      this.allpath_markers = [];
    }
    if (this.directionsDisplay || this.directionsDisplay != undefined) {
      this.directionsDisplay.setMap(null);
    }
    if (this.path_his.length > 0) {
      for (let inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
      }
    }
  }
  clearArray() {
    console.log('clear array----------------->');
    $('#appt_loader_parent').show();
    this.data2 = [];
    this.data1 = [];
    this.data3 = [];
    this.passDetailsContent = '';
    this.showbooking_content = '';
    this.new_negotiations = [];
    this.old_negotiations = [];
    this.negotiations = [];
    this.shownegos_content = '';
    this.unassignedCount = 0;
    this.assignedCount = 0;
    this.pastCount = 0;
    this.assigned_jobs = [];
    this.offers = [];
    this.past_jobs = [];
    this.clearallpassdetails();
    this.bookingCount();
    this.getmyjobs(1);
    this.getmyjobs(2);
    this.getmyjobs(3);
  }

  getslaveappointments() {
    // if(this.page_index==0){
    //   this.assigned_count=0;
    //   this.completed_count=0;
    //   this.assigned_full_count=0;
    // }
    // $("#appt_loader_parent").show();
    //   this.current_time = new Date();
    //   this.current_time_var = this.current_time.getFullYear()+'-'+("0" + (this.current_time.getMonth() + 1)).slice(-2) + '-'+this.current_time.getDate() ;
    //     var start_date;
    //     var drop_date;
    //     if(this.picker_bool!=true){
    //   this.picker_date = this.current_time_var;
    //   start_date="";
    //   drop_date="";
    // }
    // else{
    //   this.picker_date = this.picker_date ;
    //    start_date=this.picker_date;
    //    drop_date = this.drop_date;
    // }

    this._dispatcherHomeService
      .getdet({
        skip: this.offers_skip,
        limit: this.offers_limit
      })
      .subscribe(
        (res: any) => {
          console.log(
            'bookingappointments++++++++++++++++++++++++++++++++++',
            res
          );
          $('#appt_loader_parent').hide();
          const booking_data = res.data;
          this.total_offers_count = res.count;
          if (booking_data.length == 0) {
            // $(".more_tooltip_error").show();
            // setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
          } else {
            this.offers_incall = false;
            for (let inst = 0; inst < booking_data.length; inst++) {
              // converting time stamps to local time using moment
              if (booking_data[inst].pickupDate !== '0') {
                booking_data[inst].pickupDate = moment
                  .unix(booking_data[inst].pickupDate)
                  .format('DD MMM  YYYY, hh mm a');
              }
              if (booking_data[inst].dropDate !== '0') {
                booking_data[inst].dropDate = moment
                  .unix(booking_data[inst].dropDate)
                  .format('DD MMM YYYY, hh mm a');
              }
              if (booking_data[inst].postedOn !== '0') {
                booking_data[inst].postedOn = moment(
                  booking_data[inst].postedOn
                ).format('DD MMM YYYY, hh mm a');
              }
              this.offers.push(booking_data[inst]);
            }
            console.log('aftermodifying', booking_data);
          }
          this.map_loader = false;
        },
        err => {
          // if (err.status == 401) {
          //   toastr['error']('<h5>Logged out</h5>');
          //   $('#logout_popup').modal({ backdrop: 'static', keyboard: false });
          // }
          // if (err.status == 400) {
          //   toastr['error']('<h5>Bad request.. unable to do a request</h5>');
          // } else {
          //   toastr['error']('<h5>Could not connect to server!!! Please try again later</h5>');
          // }
          this.handleStatus(err.status, err.error);
          this.map_loader = false;
        }
      );
  }

  getmyjobs(val) {
    this.bookingLoader = true;
    if (val == 1) {
      this.offers = [];
      this.intervalTimersArray.forEach((item, index) => {
        clearInterval(item.id);
        // console.log('Timer Cleared For ', item);
      });
    } else if (val == 2) {
      this.assigned_jobs = [];
    } else if (val == 3) {
      this.past_jobs = [];
    }
    // this.map_loader = true;
    $('#appt_loader_parent').show();

    this._dispatcherHomeService
      .getjobs({
        type: val,
        skip: this.assigned_skip,
        limit: this.assigned_limit,
        status: '',
        fromDate: this.picker_date,
        toDate: this.drop_date,
        cityId: this._cookie.getCityId('cityid')
      })
      .subscribe(
        (res: any) => {
          // console.log('myjobs+++++++++++++++', res);
          if (val == 1) {
            this.intervalTimersArray = [];
          }
          $('#appt_loader_parent').hide();
          const booking_data = res.data.bookings;
          this.total_assigned_count = res.count;
          if (booking_data.length == 0) {
            // $(".more_tooltip_error").show();
            // setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
          } else {
            this.assigned_incall = false;
            for (let inst = 0; inst < booking_data.length; inst++) {
              // converting time stamps to local time using moment
              if (booking_data[inst].bookingDateTimestamp !== '0') {
                booking_data[inst].bookingDateTimestamp = moment
                  .unix(booking_data[inst].bookingDateTimestamp)
                  .format('DD MMM  YYYY, hh : mm a');
              }
              // if (booking_data[inst].deliveryDateTimestamp !== '0') {
              //   booking_data[inst].deliveryDateTimestamp = moment.unix(booking_data[inst].deliveryDateTimestamp).format('DD MMM YYYY, hh : mm a');
              // }
              if (booking_data[inst].timeStamp.created !== '0') {
                booking_data[inst].timeStamp.created = moment(
                  booking_data[inst].timeStamp.created * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              // if (booking_data[inst].timeStamp.expired !== 0) {
              //   booking_data[inst].timeStamp.expired = moment(booking_data[inst].timeStamp.expired * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.cancelled !== 0) {
              //   booking_data[inst].timeStamp.cancelled = moment(booking_data[inst].timeStamp.cancelled * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.accepted !== 0) {
              //   booking_data[inst].timeStamp.accepted = moment(booking_data[inst].timeStamp.accepted * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.arrived !== 0) {
              //   booking_data[inst].timeStamp.arrived = moment(booking_data[inst].timeStamp.arrived * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.reachedDrop !== 0) {
              //   booking_data[inst].timeStamp.reachedDrop = moment(booking_data[inst].timeStamp.reachedDrop * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.onTheWay !== 0) {
              //   booking_data[inst].timeStamp.onTheWay = moment(booking_data[inst].timeStamp.onTheWay * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.unloaded !== 0) {
              //   booking_data[inst].timeStamp.unloaded = moment(booking_data[inst].timeStamp.unloaded * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.journeyComplete !== 0) {
              //   booking_data[inst].timeStamp.journeyComplete = moment(booking_data[inst].timeStamp.journeyComplete * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].timeStamp.journeyStart !== 0) {
              //   booking_data[inst].timeStamp.journeyStart = moment(booking_data[inst].timeStamp.journeyStart * 1000).format('DD MMM YYYY, hh : mm a');
              // }
              // if (booking_data[inst].activities !== undefined) {
              //   for (let bookingstatus = 0; bookingstatus < booking_data[inst].activities.length; bookingstatus++) {
              //     booking_data[inst].activities[bookingstatus].timeConverted = moment(booking_data[inst].activities[bookingstatus].time).format('DD MMM YYYY, hh : mm a');
              //   }
              // }
              switch (val) {
                case 1:
                  this.showTimer(booking_data[inst]);
                  this.offers.push(booking_data[inst]);
                  this.offers = uniqBy(this.offers, 'bookingId');
                  // console.log('offers data--->', this.offers, booking_data[inst]);
                  break;
                case 2:
                  this.assigned_jobs.push(booking_data[inst]);
                  this.assigned_jobs = uniqBy(this.assigned_jobs, 'bookingId');
                  // console.log('Assigned jobs-->', this.assigned_jobs);
                  break;
                case 3:
                  this.past_jobs.push(booking_data[inst]);
                  this.past_jobs = uniqBy(this.past_jobs, 'bookingId');
                  // console.log('pastjobs data--->', this.offers, booking_data[inst]);
                  break;
              }
            }
            // console.log('aftermodifying', booking_data);
          }
          this.bookingLoader = false;
          this.map_loader = false;
        },
        err => {
          this.map_loader = false;
          this.bookingLoader = false;
          // if (err.status == 401) {
          //   // toastr['error']('<h5>Logged out</h5>');
          //   $('#logout_popup').modal({ backdrop: 'static', keyboard: false });
          // }
          // if (err.status == 400) {
          //   toastr['error']('<h5>Bad request.. unable to do a request</h5>');
          // } else {
          //   // toastr['error']('<h5>Could not connect to server!!! Please try again later</h5>');
          // }
          this.handleStatus(err.status, err.error);
        }
      );
  }

  showTimer(data) {
    // console.log('Show Timer!!!');
    const bidClosingTime = data.dispatchTime.bidClosingTime;
    const bidExpiryTime = data.dispatchTime.bookingExpiryTime;
    const currentTime = moment().unix();
    const diffbidClosingTime = bidClosingTime - currentTime;
    const diffExpiryTime = bidExpiryTime - currentTime;
    // console.log('diffExpiryTime', diffExpiryTime);
    // console.log('diffBookingExpiryTime', diffbidClosingTime);
    // bid closing time
    if (data.bidding == false) {
      $('#closingTime' + data.bookingId).text('DISABLED');
    }
    if (diffbidClosingTime > 0) {
      if (data.bidding == true) {
        let duration = moment.duration(
          diffbidClosingTime * 1000,
          'milliseconds'
        );
        // console.log('durationClosingTime', duration);
        const interval = 1000;
        const x = setInterval(() => {
          if (duration <= 0) {
            clearInterval(x);
            $('#closingTime' + data.bookingId).text('CLOSED');
            const i = this.intervalTimersArray.findIndex(item => item.id === x);
            if (i !== -1) {
              this.intervalTimersArray.splice(i, 1);
            }
          } else {
            duration = moment.duration(duration - interval, 'milliseconds');
            $('#closingTime' + data.bookingId).text(
              duration.days() +
              'd ' +
              ' : ' +
              duration.hours() +
              'h ' +
              ' : ' +
              duration.minutes() +
              'm' +
              ' : ' +
              duration.seconds() +
              's'
            );
          }
        }, interval);
        this.intervalTimersArray.push({ booking: data.bookingId, id: x });
        // console.log('SetInterval Added X', this.intervalTimersArray);
      }
    } else {
      setTimeout(function () {
        $('#closingTime' + data.bookingId).text('CLOSED');
      }, 1000);
    }
    if (diffExpiryTime > 0) {
      let duration = moment.duration(diffExpiryTime * 1000, 'milliseconds');
      // console.log('durationExpirytime', duration);
      const interval = 1000;
      const y = setInterval(() => {
        if (duration <= 0) {
          clearInterval(y);
          $('#expiryTime' + data.bookingId).text('EXPIRED');
          const i = this.intervalTimersArray.findIndex(item => item.id === y);
          if (i !== -1) {
            this.intervalTimersArray.splice(i, 1);
          }
        } else {
          duration = moment.duration(duration - interval, 'milliseconds');
          $('#expiryTime' + data.bookingId).text(
            duration.days() +
            'd ' +
            ' : ' +
            duration.hours() +
            'h ' +
            ' : ' +
            duration.minutes() +
            'm' +
            ' : ' +
            duration.seconds() +
            's'
          );
        }
      }, interval);
      this.intervalTimersArray.push({ booking: data.bookingId, id: y });
      // console.log('SetInterval Added Y', this.intervalTimersArray);
    } else {
      setTimeout(function () {
        $('#expiryTime' + data.bookingId).text('EXPIRED');
      }, 1000);
    }
  }

  zoomin() {
    const m = this.map1.getZoom();
    this.map1.setZoom(m - 1);
  }
  zoomout() {
    const m = this.map1.getZoom();
    this.map1.setZoom(m + 1);
  }

  changefilter(styleIndex, typeId = false) {
    // console.log(this.map1);
    if (typeId) {
      this.map1.setMapTypeId(google.maps.MapTypeId.SATELLITE);
    } else {
      this.map1.setMapTypeId(google.maps.MapTypeId.ROADMAP);
      this.map1.setOptions({ styles: mapStyle[styleIndex] });
    }
  }

  // rating_b_details: any;
  // // single booking api call
  // callsingalbooking(bid) {
  //   this._dispatcherService.getdet({
  //     "ent_page_index": "0",
  //     "ent_booking_id": bid,
  //   }).subscribe((res: any) => {
  //     console.log("singalbooking+++++++++++", res);
  //     if (res.errFlag == 0) {
  //       this.rating_b_details = res.data.appointments[0];
  //       console.log("singalbooking+++++++++++rating_b_details", this.rating_b_details);
  //       setTimeout(() => {
  //         $('#review_popup').modal({ backdrop: 'static', keyboard: false });
  //       }, 200)
  //       console.log("rating_b_details", this.rating_b_details);
  //     } else {
  //       alert(res.errMsg);
  //     }
  //   }, (err) => {
  //     // var error = JSON.parse(err.error);
  //     // var listErr = error.statusCode;
  //     // this.handleStatus(error.status, error, err);
  //   }
  // );
  // }

  // single booking
  singleBooking(bookingId, status) {
    // alert('two times');
    if (this.unassign == true) {
      status = 3;
    } else {
      status = 2;
    }
    const singleBookingId = bookingId;
    this._dispatcherHomeService
      .negotiations({
        bookingId: singleBookingId,
        status: status
      })
      .subscribe(
        (res: any) => {
          console.log('completedbooking--->', res);
          const bookingData = res.dataForDispatcher;
          if (bookingData.bookingDateTimestamp !== '0') {
            bookingData.bookingDateTimestamp = moment
              .unix(bookingData.bookingDateTimestamp)
              .format('DD MMM  YYYY, hh mm a');
          }
          // if (bookingData.deliveryDateTimestamp !== '0') {
          //   bookingData.deliveryDateTimestamp = moment.unix(bookingData.deliveryDateTimestamp).format('DD MMM YYYY, hh mm a');
          // }
          if (bookingData.timeStamp.created !== '0') {
            bookingData.timeStamp.created = moment(
              bookingData.timeStamp.created * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.expired !== 0) {
            bookingData.timeStamp.expired = moment(
              bookingData.timeStamp.expired * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.cancelled !== 0) {
            bookingData.timeStamp.cancelled = moment(
              bookingData.timeStamp.cancelled * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.accepted !== 0) {
            bookingData.timeStamp.accepted = moment(
              bookingData.timeStamp.accepted * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.arrived !== 0) {
            bookingData.timeStamp.arrived = moment(
              bookingData.timeStamp.arrived * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.reachedDrop !== 0) {
            bookingData.timeStamp.reachedDrop = moment(
              bookingData.timeStamp.reachedDrop * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.onTheWay !== 0) {
            bookingData.timeStamp.onTheWay = moment(
              bookingData.timeStamp.onTheWay * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.unloaded !== 0) {
            bookingData.timeStamp.unloaded = moment(
              bookingData.timeStamp.unloaded * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.journeyComplete !== 0) {
            bookingData.timeStamp.journeyComplete = moment(
              bookingData.timeStamp.journeyComplete * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (bookingData.timeStamp.journeyStart !== 0) {
            bookingData.timeStamp.journeyStart = moment(
              bookingData.timeStamp.journeyStart * 1000
            ).format('DD MMM YYYY, hh mm a');
          }
          if (this.dcomplete == true) {
            this.past_jobs.splice(0, 0, bookingData);
            this.pastCount++;
            this.assignedCount--;
          } else if (this.dcomplete == false) {
            // alert('unassign booking');
            jQuery('.right_marker').trigger('click');
            this.assigned_jobs.splice(0, 0, bookingData);
            // FIXME:
            // this.unassignedCount--;
            // this.assignedCount++;
          }
        },
        err => {
          // if (err.status == 401) {
          //   toastr['error']('<h5>Logged out</h5>');
          //   $('#logout_popup').modal({ backdrop: 'static', keyboard: false });
          // }
          // if (err.status == 400) {
          //   toastr['error']('<h5>Bad request.. unable to do a request</h5>');
          // } else {
          //   toastr['error']('<h5>Could not connect to server!!! Please try again later</h5>');
          // }
          this.handleStatus(err.status, err.error);
          this.map_loader = false;
        }
      );
  }

  unassign = false;
  unassgnBooking = false;
  moveLoadboard = false;
  unasgnTab = 2;
  // dispatch booking
  unassignBooking(item) {
    this._dispatcherHomeService
      .unassignBooking({
        bookingId: item.toString(),
        callFrom: this.unasgnTab
      })
      .subscribe(
        (res: any) => {
          // this.showbooking_content = [];
          this.dcomplete = false;
          this.unassign = true;
          const index = this.offers.findIndex(x => x.bookingId == item);
          if (index !== -1) {
            this.offers[index].status = '1';
            this.offers[index].statusText = 'New';
            const booking = this.offers[index];
            this.offers.splice(index, 1);
            this.bookingCount();
            this.assigned_jobs.splice(0, 0, booking);
            this.assigned_jobs = this.assigned_jobs.filter(
              val => val.unAssigned
            );
            console.log('offers array2', this.assigned_jobs, this.offers);
            const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
              'rotate_pointer'
            );
            if (isRightMarkerIsOpen) {
              jQuery('.right_marker').trigger('click');
            }
          } else {
            this.singleBooking(item, '1');
          }
          // } else {
          const index1 = this.past_jobs.findIndex(x => x.bookingId == item);
          if (index1 !== -1) {
            this.past_jobs[index1].status = '1';
            this.past_jobs[index1].statusText = 'New';
            const booking = this.past_jobs[index1];
            this.past_jobs.splice(index1, 1);
            this.bookingCount();
            this.assigned_jobs.splice(0, 0, booking);
            this.assigned_jobs = this.assigned_jobs.filter(
              val => val.unAssigned
            );
            console.log('past jobs array', this.past_jobs, this.assigned_jobs);
          } else {
            this.singleBooking(item, '1');
          }
          // }
        },
        err => {
          // if (err.status == 401) {
          //   toastr['error']('<h5>Logged out</h5>');
          //   $('#logout_popup').modal({ backdrop: 'static', keyboard: false });
          // }
          // if (err.status == 400) {
          //   toastr['error']('<h5>Bad request.. unable to do a request</h5>');
          // } else {
          //   toastr['error']('<h5>Could not connect to server!!! Please try again later</h5>');
          // }
          this.handleStatus(err.status, err.error);
          this.map_loader = false;
        }
      );
  }

  // right side bar functions
  showOnlineDrivers() {
    $('.connections_div').hide();
    $('#online_drivers1').show();
    $('#online_drivers_head').addClass('active');
    $('#total_drivers_head').removeClass('active');
    $('#ongoing_drivers_head').removeClass('active');
  }
  showBusyDrivers() {
    $('.connections_div').hide();
    $('#ongoing_drivers1').show();
    $('#online_drivers_head').removeClass('active');
    $('#total_drivers_head').removeClass('active');
    $('#ongoing_drivers_head').addClass('active');
  }
  showTotalDrivers() {
    $('.connections_div').hide();
    $('#total_drivers1').show();
    $('#online_drivers_head').removeClass('active');
    $('#total_drivers_head').addClass('active');
    $('#ongoing_drivers_head').removeClass('active');
  }

  // filtered_drivers = [];
  // filtered_drivers_total = [];
  // filtered_drivers_offline = [];
  nearestI: any;
  nearestJobid: any;
  nearestItem: any;
  bookingId: any;
  // driver based on status filters
  search_driver_filter_vechicles() {
    // console.log(this.selected_vehicle_name, this.initialActiveDrivers, this.initialTotalDrivers);
    console.log(
      this.selected_vehicletype,
      this.initialActiveDrivers,
      this.initialTotalDrivers
    );
    // this.sorting_vechicletype = '';
    // for (let inst = 0; inst < this.selected_vehicletype.length; inst++) {
    //   if (this.sorting_vechicletype == '')
    //     this.sorting_vechicletype = this.selected_vehicletype[inst];
    //   else
    //     this.sorting_vechicletype = this.sorting_vechicletype + ',' + this.selected_vehicletype[inst];
    //   $('#drivers_filters').trigger('click');
    //   this.passDetails(this.nearestI, this.nearestJobid, this.nearestItem);
    // }
    // this.filter = '1';
    // $('.left_window_body.active').trigger('click');
    // TODO: filter driver using vehicle type by vivek :)
    this._dispatcherHomeService
      .nearest_drivers({
        bookingId: this.currentBookingID
          ? this.currentBookingID.toString()
          : this.showbooking_content.bookingId.toString(),
        typeIds: this.selected_vehicletype.join(),
        sortBy: this.filter.toString(),
        sortOrder: this.sort.toString(),
        search: this.search_driver_text,
        operatorDrivers: this.showOnlyOperatorDrivers ? '1' : '0'
      })
      .subscribe(
        (res: any) => {
          this.map_loader = false;
          this.filtered_drivers_total = [];
          this.filtered_drivers = [];
          this.filtered_drivers_offline = [];
          this.filtered_drivers_busy = [];
          this.driverArray = res.data.driverArray;
          this.vechiletypes = res.data.typesArray;
          this.selected_vehicletype = [];
          this.initialActiveDrivers = [];
          this.initialTotalDrivers = [];

          if (res.data.driverArray == undefined) {
            // EMPTYING ALL THE ARRAYS IF NO DRIVERS ARE FOUND
            $('#loading_drivers_parent').hide();
          } else if (res.data.driverArray !== undefined) {
            // SETTING ALL THE DRIVERS BASED ON THEIR STATUS
            if (this.showbooking_content.dispatched !== undefined) {
              for (
                let inst = 0;
                inst < this.showbooking_content.dispatched.length;
                inst++
              ) {
                this.dispatchedDriverIdArray.push(
                  this.showbooking_content.dispatched[inst].driverId
                );
              }
            }

            for (let key = 0; key < res.data.driverArray.length; key++) {
              const index = this.dispatchedDriverIdArray.indexOf(
                res.data.driverArray[key].id
              );
              if (index !== -1) {
                res.data.driverArray[key]['dispatch_count'] = 1;
              } else {
                res.data.driverArray[key]['dispatch_count'] = 0;
              }
              let time = res.data.driverArray[key].lastSeen; // TAKES LASTONLINE AND CONVERTS TO HUMAN READABLE FORMAT
              if (time > 60) {
                if (time < 3600) {
                  time = time / 60;
                  time = time.toFixed(0);
                  res.data.driverArray[key].lastSeen = time + ' min ago';
                } else if (time < 86400) {
                  time = time / 3600;
                  time = time.toFixed(0);
                  res.data.driverArray[key].lastSeen = time + ' hours ago';
                } else if (time > 86400) {
                  time = time / 86400;
                  time = time.toFixed(0);
                  res.data.driverArray[key].lastSeen = time + ' days ago';
                }
              } else {
                res.data.driverArray[key].lastSeen = time + ' sec ago';
              }
              this.filtered_drivers_total.push(res.data.driverArray[key]);
              this.initialTotalDrivers.push(res.data.driverArray[key]);
              // console.log('Filtered total', this.filtered_drivers_total);                 // TOTAL DRIVERS PUSH IN TO AN ARRAY
              if (res.data.driverArray[key].status == 3) {
                this.filtered_drivers.push(res.data.driverArray[key]);
                this.initialActiveDrivers.push(res.data.driverArray[key]);
                // ONLINE DRIVERS PUSH IN TO AN ARRAY
                const pos2 = new google.maps.LatLng(
                  res.data.driverArray[key].location.latitude,
                  res.data.driverArray[key].location.longitude
                );
                const icon = {
                  url: res.data.driverArray[key].vehicleDetail.vehicleMapIcon, // url
                  scaledSize: new google.maps.Size(30, 30), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0) // anchor
                };
                const marker = new google.maps.Marker({
                  icon: icon,
                  position: pos2,
                  map: this.map,
                  animation: google.maps.Animation.DROP
                });
                marker.driverId = res.data.driverArray[key].id;
                this.route_markers.push(marker);
              } else if (res.data.driverArray[key].status == 4) {
                this.filtered_drivers_offline.push(res.data.driverArray[key]); // OFFLINE DRIVERS PUSH IN TO AN ARRAY
              } else if (res.data.driverArray[key].status == 5) {
                this.filtered_drivers_busy.push(res.data.driverArray[key]); // BUSY DRIVERS PUSH IN TO AN ARRAY
              }
            }
          }
          // console.log('this.filtered_drivers', this.filtered_drivers);
        },
        err => {
          this.handleStatus(err.status, err.error);
        }
      );
    // console.log(this.filtered_drivers_total, this.filtered_drivers);
  }
  notransition() {
    // stops all when selecting vehicle types transitions
    event.stopPropagation();
  }
  initialActiveDrivers = [];
  selected_vehicle_name = [];
  initialTotalDrivers = [];
  search_driver_filter_select(filter, id, name) {
    // selects vehicle and push to selected vehicle type and viceversa
    // console.log('Vehical Filter', filter, id);
    if ($('#styled-checkbox-1' + id).is(':checked')) {
      this.selected_vehicletype.push(id);
      this.selected_vehicle_name.push(name);
    } else {
      const vehicle = this.selected_vehicletype.findIndex(x => x == id);
      this.selected_vehicletype.splice(vehicle, 1);
      const vehicleName = this.selected_vehicle_name.findIndex(x => x == name);
      this.selected_vehicle_name.splice(vehicleName, 1);
    }
    // console.log(this.selected_vehicletype);
  }
  search_driver_filter(filter?, sort?) {
    this.filtered_drivers = [];
    this.filtered_drivers_offline = [];
    this.filtered_drivers_busy = [];
    this.filtered_drivers_total = [];
    this.initialActiveDrivers = [];
    this.initialTotalDrivers = [];
    this.selected_vehicle_name = [];
    if (filter && sort) {
      this._dispatcherHomeService
        .nearest_drivers({
          bookingId: this.currentBookingID
            ? this.currentBookingID.toString()
            : this.showbooking_content.bookingId.toString(),
          typeIds: '',
          sortBy: this.filter.toString(),
          sortOrder: this.sort.toString(),
          search: this.search_driver_text,
          operatorDrivers: this.showOnlyOperatorDrivers ? '1' : '0'
        })
        .subscribe(
          (res: any) => {
            this.map_loader = false;
            this.filtered_drivers_total = [];
            this.filtered_drivers = [];
            this.filtered_drivers_offline = [];
            this.filtered_drivers_busy = [];
            this.driverArray = res.data.driverArray;
            this.vechiletypes = res.data.typesArray;
            this.selected_vehicletype = [];
            this.initialActiveDrivers = [];
            this.initialTotalDrivers = [];

            if (res.data.driverArray == undefined) {
              // EMPTYING ALL THE ARRAYS IF NO DRIVERS ARE FOUND
              $('#loading_drivers_parent').hide();
            } else if (res.data.driverArray !== undefined) {
              // SETTING ALL THE DRIVERS BASED ON THEIR STATUS
              if (this.showbooking_content.dispatched !== undefined) {
                for (
                  let inst = 0;
                  inst < this.showbooking_content.dispatched.length;
                  inst++
                ) {
                  this.dispatchedDriverIdArray.push(
                    this.showbooking_content.dispatched[inst].driverId
                  );
                }
              }

              for (let key = 0; key < res.data.driverArray.length; key++) {
                const index = this.dispatchedDriverIdArray.indexOf(
                  res.data.driverArray[key].id
                );
                if (index !== -1) {
                  res.data.driverArray[key]['dispatch_count'] = 1;
                } else {
                  res.data.driverArray[key]['dispatch_count'] = 0;
                }
                let time = res.data.driverArray[key].lastSeen; // TAKES LASTONLINE AND CONVERTS TO HUMAN READABLE FORMAT
                if (time > 60) {
                  if (time < 3600) {
                    time = time / 60;
                    time = time.toFixed(0);
                    res.data.driverArray[key].lastSeen = time + ' min ago';
                  } else if (time < 86400) {
                    time = time / 3600;
                    time = time.toFixed(0);
                    res.data.driverArray[key].lastSeen = time + ' hours ago';
                  } else if (time > 86400) {
                    time = time / 86400;
                    time = time.toFixed(0);
                    res.data.driverArray[key].lastSeen = time + ' days ago';
                  }
                } else {
                  res.data.driverArray[key].lastSeen = time + ' sec ago';
                }
                this.filtered_drivers_total.push(res.data.driverArray[key]);
                this.initialTotalDrivers.push(res.data.driverArray[key]);
                // console.log('Filtered total', this.filtered_drivers_total);                 // TOTAL DRIVERS PUSH IN TO AN ARRAY
                if (res.data.driverArray[key].status == 3) {
                  this.filtered_drivers.push(res.data.driverArray[key]);
                  this.initialActiveDrivers.push(res.data.driverArray[key]);
                  // ONLINE DRIVERS PUSH IN TO AN ARRAY
                  const pos2 = new google.maps.LatLng(
                    res.data.driverArray[key].location.latitude,
                    res.data.driverArray[key].location.longitude
                  );
                  const icon = {
                    url: res.data.driverArray[key].vehicleDetail.vehicleMapIcon, // url
                    scaledSize: new google.maps.Size(30, 30), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(0, 0) // anchor
                  };
                  const marker = new google.maps.Marker({
                    icon: icon,
                    position: pos2,
                    map: this.map,
                    animation: google.maps.Animation.DROP
                  });
                  marker.driverId = res.data.driverArray[key].id;
                  this.route_markers.push(marker);
                } else if (res.data.driverArray[key].status == 4) {
                  this.filtered_drivers_offline.push(res.data.driverArray[key]); // OFFLINE DRIVERS PUSH IN TO AN ARRAY
                } else if (res.data.driverArray[key].status == 5) {
                  this.filtered_drivers_busy.push(res.data.driverArray[key]); // BUSY DRIVERS PUSH IN TO AN ARRAY
                }
              }
            }
            // console.log('this.filtered_drivers', this.filtered_drivers);
          },
          err => {
            this.handleStatus(err.status, err.error);
          }
        );
    }
    if (sort == 1 || sort == -1) {
      this.filter = filter;
      this.sort = sort;
      $('.left_window_body.active').trigger('click');
      $('#drivers_filters1').trigger('click');
      this.passDetails(this.nearestI, this.nearestJobid, this.nearestItem);
    }
  }

  // Function for Togglling the Show Operator Only Drivers
  toggleShowOperatorDriver() {
    this.showOnlyOperatorDrivers = !this.showOnlyOperatorDrivers;
    $(`#body_${this.showbooking_content.bookingId}`).trigger('click');
    console.log(`#body_${this.showbooking_content.bookingId}`);
  }

  // clear filters
  clear_all_filters() {
    event.preventDefault();
    // this.search_driver_filter();
    console.log('clear filter', this.showbooking_content);
    this.sorting_vechicletype = '';
    this.searchStr = '';
    this.sort = '';
    this.filter = '';
    this.selected_vehicletype = [];
    this.filtered_drivers = [...this.initialActiveDrivers];
    this.filtered_drivers_total = [...this.initialTotalDrivers];
    // console.log($('.styled-checkbox'));
    $('.styled-checkbox').attr('checked', false);
    // jQuery('.left_window_body.active').trigger('click');
    jQuery(`#body_${this.showbooking_content.bookingId}`).trigger('click');

    // this.passDetails(this.nearestI, this.nearestJobid, this.nearestItem);
  }
  dispatchBook = false;
  // dispatch booking
  dispatch_booking() {
    this.dispatchBook = true;
    $('#booking_loader_popup').show();
    $('#confirm_booking_close_but').trigger('click');
    this._dispatcherHomeService
      .dispatch_booking({
        bookingId: this.filtered_bid.toString(),
        driverId: this.progress_bar_id
      })
      .subscribe(
        (res: any) => {
          $('#booking_loader_popup').hide();
          console.log(res);
          const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
            'rotate_pointer'
          );
          if (!isRightMarkerIsOpen) {
            jQuery('.right_marker').trigger('click');
          }
        },
        err => {
          this.handleStatus(err.status, err.error);
          this.map_loader = false;
        }
      );
  }

  // dispatch booking
  offer_manager(e, email, item, no) {
    this.confirm_booking(email, e);
  }
  filtered_mail: any;
  progress_bar_id: any;
  confirm_booking(mail, user) {
    this.filtered_mail = mail;
    this.progress_bar_id = user;
    $('#confirm_booking').modal('show');
  }
  tasklist_pencount: any;
  tasklist_number: any;
  task_list_array = [];
  driver_formated_address: any;
  driversDetailsContent: any;
  task_list_count: any;
  isDriverTabVisible: any;
  show_driver_details(item) {
    // alert();
    console.log('Driver detail panel-->', item);
    event.stopPropagation();
    // $("#driver_formated_address").text("");
    if (item.location.latitude !== undefined) {
      const geocoder = new google.maps.Geocoder();
      const locate = {
        lat: parseFloat(item.location.latitude),
        lng: parseFloat(item.location.longitude)
      };
      geocoder.geocode({ location: locate }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          // console.log(results);

          if (results[1]) {
            this.driver_formated_address = results[1].formatted_address;
            // console.log( this.driver_formated_address );
            $('#driver_formated_address').text(results[1].formatted_address);
          } else {
            window.alert('No results found');
          }
        }
      });
    }
    // for (let inst = 0; inst < this.filtered_drivers_total.length; inst++) {
    //   if (this.filtered_drivers_total[inst]._id == item.MongoId) {
    //     item.DeviceType = this.filtered_drivers_total[inst].DeviceType;
    //     item.last_time_stamp = this.filtered_drivers_total[inst].last_time_stamp;
    //     item.PhoneVersion = this.filtered_drivers_total[inst].PhoneVersion;
    //     item.batPer = this.filtered_drivers_total[inst].batPer;
    //     item.locationChk = this.filtered_drivers_total[inst].locationChk;
    //   }
    // }
    // this.task_list_array = [];
    // this.task_list_count = 0;
    // for (const element in this.tasklist_pencount) {
    //   if (this.tasklist_pencount[element]._id == item.id) {
    //     this.tasklist_number = this.tasklist_pencount[element].total;
    //     break;
    //   } else {
    //     this.tasklist_number = 0;
    //   }
    // }
    item.address = this.driver_formated_address;
    // console.log(this.driver_formated_address);
    this.driversDetailsContent = item;
    // this.isDriverTabVisible = true;
    // jQuery('#right_front_diver').addClass('activeMove');
  }
  close_popup() {
    // jQuery('#right_front_diver').removeClass('activeMove');
    // this.isDriverTabVisible = false;
  }
  // trackup for better performance
  trackByFn(index, item) {
    // console.log('track by---->>', index, item);
    return index || item; // or item.id
  }

  // Change the map Location based on city selected
  changeMapView(city) {
    console.log('City Changed', city);
    this.map1.setCenter({
      lat: city.location.latitude,
      lng: city.location.longitude
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    // if (this._client && this._client.isConnected()) {
    //   this._client.unsubscribe('godsview/' + this.lastChannelId + this.roleChannel + '/#', null);
    //   this._client.disconnect();
    // }
  }

  vehicleImageError(event) {
    event.target.src = 'https://res.cloudinary.com/appscripimgs/image/upload/v1571124663/truckr_images/delivery-truck_ewcdsf.svg';
  }
  send_otp_to_driver(booking) {
    console.log('id', booking);
    let regData = {
      bookingId: booking.bookingId.toString(),
      userId: booking.driverDetails.driverId,
      // userId: booking.slaveDetails.slaveId, booking.driverDetails.driverId,
      code: this.otp_entered,
      trigger: 4
    }
    this._dispatcherHomeService.postJobStartByDriver(regData).subscribe((res) => {
      console.log('res emergency', res);
      toastr['success'](`<h5>${res['message']}</h5>`);
      $('#otp_popup').modal('hide');
    }, err => {
      console.log('error ', err);
      $('.booking_loader_parent').hide();
      const error = err.error;
      const listErr = error.statusCode;
      this.handleStatus(err.status, err.error);
    })
  }
}
